import './shared/DevolucionDosis.css';
import { PharmacyMetric, PharmacySelect, PharmacyPagination, PharmacyDownloadDialog, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, CircularProgress, Tooltip, Alert, Snackbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import { usePermisos } from '../hooks/usePermisos';

const fmtFecha = (s) => {
  if (!s) return '-';
  const str = String(s).trim();
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) return str;
  const parte = str.split('T')[0].split(' ')[0];
  const bits = parte.split('-');
  if (bits.length !== 3) return '-';
  const [anio, mes, dia] = bits;
  if (!anio || !mes || !dia || anio === '0001') return '-';
  return `${dia.padStart(2,'0')}/${mes.padStart(2,'0')}/${anio}`;
};
const hoy = () => {const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;};
const horaActual = () => new Date().toTimeString().slice(0,5);
const SERVICIOS = ['GINECOLOGÍA','CIRUGÍA','TRAUMA SHOCK','UCIN','MEDICINA GENERAL'];

// ── Helpers UI ────────────────────────────────────────────────────────────────
const Lbl = ({ children }) => (
  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase', mb:0.4 }}>{children}</Typography>
);

const Inp = ({ type='text', value, onChange, readOnly, placeholder, mono, blue, style={} }) => (
  <input type={type} value={value} onChange={onChange} readOnly={readOnly} placeholder={placeholder}
    style={{ width:'100%', height:34, padding:'0 10px', border:`1px solid ${blue&&value?`${IOS.blue}50`:IOS.separator}`,
      borderRadius:8, fontSize:'0.8rem', color:readOnly?IOS.label2:IOS.label,
      backgroundColor:readOnly?(blue?`${IOS.blue}08`:IOS.bg):IOS.surface, outline:'none',
      boxSizing:'border-box', fontFamily:mono?'monospace':'inherit', ...style }}
    onFocus={e=>{ if(!readOnly) e.target.style.borderColor=IOS.blue; }}
    onBlur={e=>{ e.target.style.borderColor=blue&&value?`${IOS.blue}50`:IOS.separator; }} />
);

// Sel custom
const Sel = PharmacySelect;

const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const MESES_LARGO = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const parseYMD = (s) => { if(!s) return new Date(); const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };

const DatePickerIOS = ({ value, onChange, w='100%' }) => {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);
  const ref = useRef(null);
  const popupRef = useRef(null);
  const selDate = value ? parseYMD(value) : null;
  const [viewMonth, setViewMonth] = useState(selDate ? selDate.getMonth() : new Date().getMonth());
  const [viewYear, setViewYear] = useState(selDate ? selDate.getFullYear() : new Date().getFullYear());

  useEffect(() => {
    const h = e => {
      const dentroTrigger = ref.current && ref.current.contains(e.target);
      const dentroPopup = popupRef.current && popupRef.current.contains(e.target);
      if (!dentroTrigger && !dentroPopup) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (ref.current) setRect(ref.current.getBoundingClientRect());
    if (selDate) { setViewMonth(selDate.getMonth()); setViewYear(selDate.getFullYear()); }
    setOpen(v=>!v);
  };

  const cambiarMes = (delta) => {
    let m = viewMonth + delta, y = viewYear;
    if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; }
    setViewMonth(m); setViewYear(y);
  };

  const elegirDia = (dia) => { onChange(toYMD(new Date(viewYear, viewMonth, dia))); setOpen(false); };

  const hoyD = new Date();
  const primerDiaSemana = new Date(viewYear, viewMonth, 1).getDay();
  const totalDias = new Date(viewYear, viewMonth+1, 0).getDate();
  const celdas = [...Array(primerDiaSemana).fill(null), ...Array.from({length:totalDias},(_,i)=>i+1)];
  const labelFecha = selDate ? `${String(selDate.getDate()).padStart(2,'0')}/${String(selDate.getMonth()+1).padStart(2,'0')}/${selDate.getFullYear()}` : '';

  return (
    <Box ref={ref} sx={{ position:'relative', width:w }}>
      <Box className="pharmacy-layout" onClick={handleOpen}
        sx={{ height:34, px:1.2, display:'flex', alignItems:'center', gap:0.8,
          border:`1px solid ${open?IOS.blue:IOS.separator}`, borderRadius:'8px',
          bgcolor:IOS.surface, cursor:'pointer', userSelect:'none',
          boxShadow:'none', transition:'all 0.15s', boxSizing:'border-box' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <Typography sx={{ fontSize:'0.8rem', color:IOS.label, flex:1, whiteSpace:'nowrap' }}>{labelFecha}</Typography>
      </Box>

      {open && rect && ReactDOM.createPortal(
        <Box ref={popupRef} sx={{ position:'fixed', top:rect.bottom+4, left:rect.left, zIndex:99999,
          bgcolor:IOS.surface, border:`1px solid ${IOS.separator}`, borderRadius:'14px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.16)', width:260, p:1.5 }}>

          <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(-1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </Box>
            <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:IOS.label }}>{MESES_LARGO[viewMonth]} {viewYear}</Typography>
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>cambiarMes(1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </Box>
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', mb:0.5 }}>
            {DIAS_SEMANA.map((d,i)=>(<Typography key={i} sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textAlign:'center' }}>{d}</Typography>))}
          </Box>

          <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'2px' }}>
            {celdas.map((dia,i)=>{
              if (dia===null) return <Box key={i} />;
              const esHoy = dia===hoyD.getDate() && viewMonth===hoyD.getMonth() && viewYear===hoyD.getFullYear();
              const esSel = selDate && dia===selDate.getDate() && viewMonth===selDate.getMonth() && viewYear===selDate.getFullYear();
              return (
                <Box className="pharmacy-layout" key={i} onClick={()=>elegirDia(dia)}
                  sx={{ height:30, display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'8px', cursor:'pointer',
                    bgcolor:esSel?IOS.blue:'transparent',
                    border:esHoy&&!esSel?`1.5px solid ${IOS.blue}`:'none' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:esSel?700:500, color:esSel?'white':IOS.label }}>{dia}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>, document.body
      )}
    </Box>
  );
};

const Card = ({ children, p=2.5, mb=2, style={} }) => (
  <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:{ xs:typeof p==='number'?Math.max(1.5,p-0.7):p, sm:p }, mb, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, ...style }}>{children}</Box>
);

const Paginacion = PharmacyPagination;

const TH = ({ children, center, right }) => (
  <th style={{ padding:'9px 10px', textAlign:center?'center':right?'right':'left',
    fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em',
    textTransform:'uppercase', backgroundColor:IOS.surface,
    borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap', position:'sticky', top:0, zIndex:1 }}>
    {children}
  </th>
);

// ── Modal Visor PDF — mismo diseño que Anulaciones ────────────────────────────
const ModalPdfVisor = ({ open, onClose, pdfUrl, cargando, titulo, subtitulo, frameId }) => {
  if (!open) return null;
  return (
    <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, zIndex:9999, bgcolor:'rgba(0,0,0,0.7)',
      display:'flex', alignItems:'center', justifyContent:'center', p:2, backdropFilter:'blur(4px)' }}
      onClick={() => !cargando && onClose()}>
      <Box className="pharmacy-modal-panel pharmacy-layout" onClick={e => e.stopPropagation()}
        sx={{ bgcolor:IOS.surface, borderRadius:{ xs:'0px', sm:'20px' }, overflow:'hidden',
          width:{ xs:'100vw', sm:'92vw' }, maxWidth:1000, height:{ xs:'100dvh', sm:'92vh' },
          display:'flex', flexDirection:'column', boxShadow:'0 24px 60px rgba(0,0,0,0.4)' }}>

        {/* Header */}
        <Box className="pharmacy-layout" sx={{ px:2.5, pt:2, pb:1.5, borderBottom:`1px solid ${IOS.separator}`, flexShrink:0,
          display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <Box>
            <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>{titulo}</Typography>
            {subtitulo && <Typography sx={{ fontSize:'0.72rem', color:IOS.label2, mt:0.2 }}>{subtitulo}</Typography>}
          </Box>
          <Box className="pharmacy-layout" sx={{ display:'flex', gap:1, alignItems:'center' }}>
            {pdfUrl && (
              <>
                <Box className="pharmacy-layout" component="a" href={pdfUrl} download="devolucion.pdf"
                  sx={{ height:32, px:1.5, borderRadius:'10px', border:`1px solid ${IOS.green}30`,
                    bgcolor:`${IOS.green}08`, cursor:'pointer', color:IOS.green, fontWeight:700,
                    fontSize:'0.78rem', textDecoration:'none', display:'flex', alignItems:'center', gap:0.5,
                    '&:hover':{ bgcolor:`${IOS.green}14` } }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/></svg>
                  Descargar
                </Box>
                <Box className="pharmacy-layout pharmacy-action" component="button"
                  onClick={() => { const f = document.getElementById(frameId); if(f) { f.contentWindow.focus(); f.contentWindow.print(); } }}
                  sx={{ height:32, px:1.5, borderRadius:'10px', border:`1px solid ${IOS.blue}30`,
                    bgcolor:`${IOS.blue}08`, cursor:'pointer', display:'flex', alignItems:'center', gap:0.5,
                    '&:hover':{ bgcolor:`${IOS.blue}14` } }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:700, color:IOS.blue }}>Imprimir</Typography>
                </Box>
              </>
            )}
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={onClose}
              sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA',
                cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center',
                '&:hover':{ bgcolor:'#D1D1D6' } }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </Box>
          </Box>
        </Box>

        {/* Iframe */}
        <Box sx={{ flex:1, overflow:'hidden', bgcolor:'#525659' }}>
          {cargando
            ? <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', gap:2 }}>
                <CircularProgress sx={{ color:'white' }} />
                <Typography sx={{ color:'rgba(255,255,255,0.8)', fontSize:'0.85rem' }}>Generando reporte...</Typography>
              </Box>
            : pdfUrl
              ? <iframe id={frameId} src={pdfUrl}
                  style={{ width:'100%', height:'100%', border:'none' }} title="PDF" />
              : <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
                  <Typography sx={{ color:'rgba(255,255,255,0.6)' }}>No se pudo generar el reporte</Typography>
                </Box>
          }
        </Box>
      </Box>
    </Box>
  );
};

// ── Modal selector PDF / Excel ────────────────────────────────────────────────
const ModalExportSelector = ({ open, onClose, onPdf, onExcel, titulo, subtitulo, cargando }) => (<PharmacyDownloadDialog open={open} onClose={onClose} title={titulo || 'Descargar reporte'} subtitle={subtitulo} busy={cargando} options={[{fmt:'pdf',label:'Ver PDF',sub:'Previsualizar e imprimir',onClick:onPdf},{fmt:'excel',label:'Descargar Excel',onClick:onExcel}]}/>);
const fmtVto = (raw) => {
  if(!raw) return '';
  const clean = raw.toString().split(' ')[0].split('T')[0].trim();
  const p = clean.split('-');
  if(p.length===3 && p[0].length===4) return `${p[2].padStart(2,'0')}/${p[1].padStart(2,'0')}/${p[0]}`;
  return raw;
};

const ModalBuscadorProducto = ({ open, onClose, onSelect, ueId }) => {
  const [buscar,    setBuscar]    = useState('');
  const [lista,     setLista]     = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [filaFocus, setFilaFocus] = useState(0);
  const inputRef = useRef(null);
  const listRef  = useRef(null);
  const timer    = useRef(null);

  useEffect(()=>{ if(open){ setBuscar(''); setLista([]); setFilaFocus(0); setTimeout(()=>inputRef.current?.focus(),80); } },[open]);

  const buscarProductos = async (q) => {
    if(!q||q.length<2){ setLista([]); return; }
    setLoading(true);
    try {
      const r = await api.get('/farmacia/devoluciondosis/buscar-producto',{params:{buscar:q,idUe:ueId||0}});
      setLista(r.data.data||[]); setFilaFocus(0);
    } catch{ setLista([]); } finally{ setLoading(false); }
  };

  const handleChange = e => {
    setBuscar(e.target.value);
    clearTimeout(timer.current);
    timer.current = setTimeout(()=>buscarProductos(e.target.value), 300);
  };

  const seleccionar = (item) => {
    const rawFecha = item.medFechVto ? item.medFechVto.toString().split(' ')[0].split('T')[0].trim() : '';
    onSelect({ codigo:item.codigo, producto:item.producto, regSan:item.medRegSan||'', lote:item.medLote||'', fechaVenc:rawFecha });
    onClose();
  };

  const scrollToFila = (idx) => {
    if(!listRef.current) return;
    const items = listRef.current.querySelectorAll('[data-fila]');
    if(items[idx]) items[idx].scrollIntoView({block:'nearest',behavior:'smooth'});
  };

  const handleKeyDown = e => {
    if(e.key==='ArrowDown'){ e.preventDefault(); setFilaFocus(f=>{ const n=Math.min(f+1,lista.length-1); scrollToFila(n); return n; }); }
    else if(e.key==='ArrowUp'){ e.preventDefault(); setFilaFocus(f=>{ const n=Math.max(f-1,0); scrollToFila(n); return n; }); }
    else if(e.key==='Enter'&&lista.length>0){ e.preventDefault(); seleccionar(lista[filaFocus]); }
    else if(e.key==='Escape'){ onClose(); }
    else if(e.key==='Tab'){ e.preventDefault(); setFilaFocus(f=>{ const n=Math.min(f+1,lista.length-1); scrollToFila(n); return n; }); }
  };

  if(!open) return null;
  return ReactDOM.createPortal(
    <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{position:'fixed',inset:0,zIndex:99999,bgcolor:'rgba(0,0,0,0.45)',display:'flex',alignItems:'flex-start',justifyContent:'center',pt:'10vh',backdropFilter:'blur(3px)'}}
      onMouseDown={e=>{ if(e.target===e.currentTarget) onClose(); }}>
      <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',width:'100%',maxWidth:560,mx:2,boxShadow:'0 24px 60px rgba(0,0,0,0.22)',overflow:'hidden',display:'flex',flexDirection:'column',maxHeight:'70vh'}}>
        <Box className="pharmacy-layout" sx={{px:2,py:1.5,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',gap:1.2}}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
          <input ref={inputRef} value={buscar} onChange={handleChange} onKeyDown={handleKeyDown}
            placeholder="Buscar por nombre o código..."
            style={{flex:1,height:36,border:'none',outline:'none',fontSize:'0.88rem',color:IOS.label,backgroundColor:'transparent',fontFamily:'inherit'}}/>
          {loading&&<CircularProgress size={14} sx={{color:IOS.blue,flexShrink:0}}/>}
          <Box sx={{px:0.8,py:0.2,bgcolor:IOS.bg,borderRadius:'6px',border:`1px solid ${IOS.separator}`}}>
            <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>ESC cerrar</Typography>
          </Box>
        </Box>
        {lista.length>0&&(
          <Box className="pharmacy-layout" sx={{px:2,py:0.6,bgcolor:IOS.bg,borderBottom:`1px solid ${IOS.separator}`,display:'flex',gap:1.5}}>
            {[['↑↓','navegar'],['Enter','seleccionar'],['Tab','siguiente']].map(([k,v])=>(
              <Box className="pharmacy-layout" key={k} sx={{display:'flex',alignItems:'center',gap:0.4}}>
                <Box sx={{px:0.6,py:0.1,bgcolor:IOS.surface,borderRadius:'4px',border:`1px solid ${IOS.separator}`}}>
                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label,fontFamily:'monospace'}}>{k}</Typography>
                </Box>
                <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>{v}</Typography>
              </Box>
            ))}
          </Box>
        )}
        <Box ref={listRef} sx={{overflowY:'auto',flex:1,'&::-webkit-scrollbar':{width:3},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
          {!loading&&lista.length===0&&buscar.length>1&&<Box sx={{py:5,textAlign:'center'}}><Typography sx={{color:IOS.label2,fontSize:'0.82rem'}}>Sin resultados para "{buscar}"</Typography></Box>}
          {!loading&&lista.length===0&&buscar.length<=1&&<Box sx={{py:5,textAlign:'center'}}><Typography sx={{color:IOS.label2,fontSize:'0.82rem'}}>Escribe al menos 2 caracteres</Typography></Box>}
          {lista.map((item,i)=>(
            <Box className="pharmacy-layout" key={i} data-fila={i} onMouseDown={e=>{e.preventDefault();seleccionar(item);}} onMouseEnter={()=>setFilaFocus(i)}
              sx={{px:2,py:1,cursor:'pointer',borderBottom:`1px solid ${IOS.separator}`,bgcolor:filaFocus===i?`${IOS.blue}08`:IOS.surface,borderLeft:`3px solid ${filaFocus===i?IOS.blue:'transparent'}`,display:'flex',alignItems:'center',gap:2,transition:'all 0.08s'}}>
              <Box sx={{flex:1,minWidth:0}}>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.blue,fontFamily:'monospace',mb:0.2}}>{item.codigo}</Typography>
                <Typography sx={{fontSize:'0.8rem',color:IOS.label,fontWeight:filaFocus===i?600:400,lineHeight:1.3}}>{item.producto}</Typography>
              </Box>
              <Box className="pharmacy-layout" sx={{display:'flex',gap:1.5,flexShrink:0}}>
                {item.medRegSan&&<Box sx={{textAlign:'right'}}><Typography sx={{fontSize: '0.72rem',color:IOS.label2,textTransform:'uppercase'}}>RS</Typography><Typography sx={{fontSize:'0.7rem',fontFamily:'monospace',fontWeight:600,color:IOS.label}}>{item.medRegSan}</Typography></Box>}
                {item.medLote&&<Box sx={{textAlign:'right'}}><Typography sx={{fontSize: '0.72rem',color:IOS.label2,textTransform:'uppercase'}}>Lote</Typography><Typography sx={{fontSize:'0.7rem',fontFamily:'monospace',fontWeight:600,color:IOS.label}}>{item.medLote}</Typography></Box>}
                {item.medFechVto&&<Box sx={{textAlign:'right'}}><Typography sx={{fontSize: '0.72rem',color:IOS.label2,textTransform:'uppercase'}}>Venc.</Typography><Typography sx={{fontSize:'0.7rem',fontFamily:'monospace',fontWeight:600,color:IOS.label}}>{fmtVto(item.medFechVto)}</Typography></Box>}
              </Box>
              {filaFocus===i&&<Box sx={{flexShrink:0}}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M9 18l6-6-6-6"/></svg></Box>}
            </Box>
          ))}
        </Box>
        {lista.length>0&&<Box sx={{px:2,py:0.8,borderTop:`1px solid ${IOS.separator}`,bgcolor:IOS.bg}}><Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>{lista.length} resultado{lista.length!==1?'s':''}</Typography></Box>}
      </Box>
    </Box>, document.body
  );
};

// ══════════════════════════════════════════════════════════════════════════════
export default function DevolucionDosis() {
  const navigate = useNavigate();
  const user     = authService.getCurrentUser();
  const ueId     = user?.ueIdEstablecimiento||user?.UeIdEstablecimiento||0;
  const idEst    = user?.idEstablecimiento||user?.IdEstablecimiento||0;
  const { privilegioDeOpcion } = usePermisos();
  const privDev = privilegioDeOpcion('devoluciones', 7);
  const puedeEditar   = privDev === 'Lectura/Escritura' || privDev === 'Total';
  const puedeEliminar = privDev === 'Total';
  const userName = user?.nombreCompleto||user?.usuario||'Usuario';
  const hostName = window.location.hostname;

  const [screenError,setScreenError]=useState('');
  const detailRequest=useRef(0);
  const [tab,  setTab]  = useState(0);
  const [modo, setModo] = useState('RECETA');

  const [fdcFecha,    setFdcFecha]    = useState(hoy());
  const [fdcHora,     setFdcHora]     = useState(horaActual());
  const [fdcServicio, setFdcServicio] = useState('');
  const [fdcDni,      setFdcDni]      = useState('');
  const [fdcPaciente, setFdcPaciente] = useState('');
  const [fdcFp,       setFdcFp]       = useState('GUIA');
  const [fdcSerie,    setFdcSerie]    = useState('');
  const [fdcCorrel,   setFdcCorrel]   = useState('');
  const [fdcFechaDev, setFdcFechaDev] = useState(hoy());
  const [fdcHoraDev,  setFdcHoraDev]  = useState(horaActual());

  const [ipressList,     setIpressList]     = useState([]);
  const [filtroIpress,   setFiltroIpress]   = useState('');
  const [filtroFechaIni, setFiltroFechaIni] = useState(()=>{ const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`; });
  const [filtroFechaFin, setFiltroFechaFin] = useState(hoy());
  const [filtroDni,      setFiltroDni]      = useState('');
  const [filtroPaciente, setFiltroPaciente] = useState('');
  const [buscandoRec,    setBuscandoRec]    = useState(false);
  const [recetas,        setRecetas]        = useState([]);
  const [recetaSel,      setRecetaSel]      = useState(null);
  const [detReceta,      setDetReceta]      = useState([]);
  const [cargandoDet,    setCargandoDet]    = useState(false);
  const [cantDev,        setCantDev]        = useState({});

  const [modalProd,   setModalProd]   = useState(false);
  const [filaModal,   setFilaModal]   = useState(null);
  const [itemsMasivo, setItemsMasivo] = useState([{ id:Date.now(), medcod:'', producto:'', regSan:'', lote:'', fechaVenc:'', cantidad:'' }]);

  const [guardando, setGuardando] = useState(false);
  const guardandoRef = useRef(false);
  const [msgOk, setMsgOk] = useState('');
  const [msgErr, setMsgErr] = useState('');

  const [hFechaIni, setHFechaIni] = useState(()=>{ const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`; });
  const [hFechaFin, setHFechaFin] = useState(hoy());
  const [hServicio, setHServicio] = useState('');
  const [hBuscar,   setHBuscar]   = useState('');
  const [hEstado,   setHEstado]   = useState('');
  const [historial, setHistorial] = useState([]);
  const [cargandoH, setCargandoH] = useState(false);
  const [pagH,      setPagH]      = useState(1);
  const filasH = 20;

  const [editItem,      setEditItem]      = useState(null);
  const [editCab,       setEditCab]       = useState(null);
  const [editDet,       setEditDet]       = useState([]);
  const [cargandoEdit,  setCargandoEdit]  = useState(false);
  const [guardandoEdit, setGuardandoEdit] = useState(false);
  const [modalPendientes, setModalPendientes] = useState(false);
  const [pendientes,      setPendientes]      = useState([]);
  const [cargPend,        setCargPend]        = useState(false);
  const [cantPend,        setCantPend]        = useState({});
  const guardandoEditRef = useRef(false);
  const [msgOkEdit,  setMsgOkEdit]  = useState('');
  const [msgErrEdit, setMsgErrEdit] = useState('');
  const [modalDel,   setModalDel]   = useState(null);
  const [eliminando, setEliminando] = useState(false);

  // ── PDF visor state ───────────────────────────────────────────────────────
  const [pdfModal,    setPdfModal]    = useState(false);
  const [pdfUrl,      setPdfUrl]      = useState(null);
  const [pdfCargando, setPdfCargando] = useState(false);
  const [pdfTitulo,   setPdfTitulo]   = useState('');
  const [pdfSubtitulo,setPdfSubtitulo]= useState('');
  const [pdfFrameId,  setPdfFrameId]  = useState('dev-pdf-frame');

  // ── Selector PDF/Excel state ──────────────────────────────────────────────
  const [selModal,      setSelModal]      = useState(false);
  const [selTipo,       setSelTipo]       = useState(null);
  const [selFilaData,   setSelFilaData]   = useState(null);
  const [selExportando, setSelExportando] = useState(false);

  // ── Estados Tab Indicadores ───────────────────────────────────────────
  const añoActual = new Date().getFullYear();
  const mesActual = new Date().getMonth() + 1;
  const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                 'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  const ANIOS = Array.from({length:5},(_,i)=> añoActual - i);
  const SI_NO = ['SI','NO'];

  const [iMes,        setIMes]        = useState(mesActual);
  const [iAnio,       setIAnio]       = useState(añoActual);
  const [iServicio,   setIServicio]   = useState('');
  const [iDispDosis,  setIDispDosis]  = useState('SI');
  const [iTotalCamas, setITotalCamas] = useState('');
  const [iCamas,      setICamas]      = useState('');
  const [iChkA,       setIChkA]       = useState(false);
  const [iChkE,       setIChkE]       = useState(false);
  const [iChkI,       setIChkI]       = useState(false);
  const [iChkS,       setIChkS]       = useState(false);
  const [iChkH,       setIChkH]       = useState(false);
  const [iChkU,       setIChkU]       = useState(false);
  const [iSegIH,      setISegIH]      = useState('SI');
  const [iSegIHPac,   setISegIHPac]   = useState('');
  const [iSegAmb,     setISegAmb]     = useState('SI');
  const [iSegAmbPac,  setISegAmbPac]  = useState('');
  const [iQfSdmdu,    setIQfSdmdu]    = useState('');
  const [iQfSft,      setIQfSft]      = useState('');
  const [iQfDisp,     setIQfDisp]     = useState('');
  const [iQfDispEsp,  setIQfDispEsp]  = useState('');
  const [iSftB1,      setISftB1]      = useState('');
  const [iSftA1, setISftA1] = useState('');
  const [iSftA2, setISftA2] = useState('');
  const [iSftA3, setISftA3] = useState('');
  const [iSftA4, setISftA4] = useState('');
  const [iSftB3, setISftB3] = useState('');
  const [iErroresDisp, setIErroresDisp] = useState('');

  const [iTabla,      setITabla]      = useState([]);
  const [iCargando,   setICargando]   = useState(false);
  const [iGuardando,  setIGuardando]  = useState(false);
  const [iMsgOk,      setIMsgOk]      = useState('');
  const [iMsgErr,     setIMsgErr]     = useState('');
  const [iConsultado, setIConsultado] = useState(false);
  const [iServConsultado, setIServConsultado] = useState('');
  const [iServReg, setIServReg] = useState([]);

  // Historial indicadores
  const [ihAnio,      setIhAnio]      = useState('');
  const [ihMes,       setIhMes]       = useState('');
  const [ihLista,     setIhLista]     = useState([]);
  const [ihCargando,  setIhCargando]  = useState(false);
  const [ihVerItem,   setIhVerItem]   = useState(null);
  const [ihDelItem,   setIhDelItem]   = useState(null);
  const [ihEliminando,setIhEliminando]= useState(false);
  const [iSubTab, setISubTab] = useState(0);
  const [ihRegistroMarcado, setIhRegistroMarcado] = useState(null);
  const [modalConsol, setModalConsol] = useState(false);
  const [cDesde, setCDesde] = useState(1);
  const [cHasta, setCHasta] = useState(6);
  const [cAnio,  setCAnio]  = useState(añoActual);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  useEffect(()=>{
    if(!ueId) return;
    api.get('/farmacia/devoluciondosis/ipress',{params:{idEjecutora:ueId}})
      .then(r=>setIpressList([{id:'',nombre:'TODAS'},...(r.data.data||[])]))
      .catch(()=>{});
  },[ueId]);

  useEffect(()=>{
    if(tab!==2 || !idEst) return;
    api.get('/farmacia/devoluciondosis/indicadores-servicios-registrados',
      { params:{ mes:iMes, anio:iAnio, idEstablecimiento:idEst } })
      .then(r=>{
        const regs = r.data.data||[];
        setIServReg(regs);
        // si el servicio seleccionado ya está registrado, saltar al primero libre
        const libres = SERVICIOS.filter(s=>!regs.includes(s));
        if(!libres.includes(iServicio)) setIServicio(libres[0]||'');
      })
      .catch(()=>setIServReg([]));
  },[tab, iMes, iAnio, idEst]);

  const buscarRecetas = async () => {
    if(filtroFechaIni>filtroFechaFin){setScreenError('La fecha inicial no puede ser posterior a la final.');return;}
    ++detailRequest.current;setCargandoDet(false);setScreenError('');
    setBuscandoRec(true); setRecetas([]); setRecetaSel(null); setDetReceta([]);
    try {
      const r=await api.get('/farmacia/devoluciondosis/buscar-recetas',{ params:{ fechaInicio:filtroFechaIni, fechaFin:filtroFechaFin, idIpress:filtroIpress||null, dni:filtroDni||null, paciente:filtroPaciente||null } });
      setRecetas(r.data.data||[]);
    } catch(e){setScreenError(e.response?.data?.message||'No se pudieron buscar las recetas.');} finally{setBuscandoRec(false);}
  };

  const cargarDetalle = async (rec) => {
    const request=++detailRequest.current;
    setRecetaSel(rec); setDetReceta([]); setCargandoDet(true); setCantDev({});
    setFdcPaciente(rec.paciente||''); setFdcDni(rec.dni_clie||'');
    setFdcFp(rec.forma_pago||'RECETA'); setFdcSerie(rec.serie||''); setFdcCorrel(rec.correlativo||'');
    if(rec.vtafechreg){
      const raw = String(rec.vtafechreg).trim();
      const m = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/);
      let d = null;
      if(m) d = new Date(parseInt(m[3]), parseInt(m[2])-1, parseInt(m[1]), m[4]?parseInt(m[4]):0, m[5]?parseInt(m[5]):0);
      else   d = new Date(raw);
      if(d && !isNaN(d)){
        setFdcFecha(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`);
        setFdcHora(`${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`);
        setFdcFechaDev(hoy()); setFdcHoraDev(horaActual());
      }
    }
    try {
      const r=await api.get('/farmacia/devoluciondosis/detalle-receta',{params:{codigo:rec.codigo}});
      if(request!==detailRequest.current)return;
      const det=r.data.data||[]; setDetReceta(det);
      const init={}; det.forEach((_,i)=>{init[i]=''}); setCantDev(init);
    } catch(e){if(request===detailRequest.current){setDetReceta([]);setScreenError(e.response?.data?.message||'No se pudo cargar la receta.');}} finally{if(request===detailRequest.current)setCargandoDet(false);}
  };

  const addFila    = () => setItemsMasivo(prev=>[...prev,{id:Date.now(),medcod:'',producto:'',regSan:'',lote:'',fechaVenc:'',cantidad:''}]);
  const removeFila = (id) => setItemsMasivo(prev=>prev.filter(x=>x.id!==id));
  const updateFila = (id,field,value) => setItemsMasivo(prev=>prev.map(x=>x.id===id?{...x,[field]:value}:x));
  const dispCant   = (v) => (!v||v==='0'||v===0)?'':v;

  const guardar = async () => {
    if(!puedeEditar||guardandoRef.current) return;
    if(!fdcServicio){setMsgErr('Selecciona el servicio');return;}
    let detalle=[];
    if(modo==='RECETA'){
      detalle=detReceta.map((d,i)=>({ medcod:d.medcod, regSan:d.medregsan||'', lote:d.medlote||'', fechaVenc:d.medfecvto||null, cantidad:parseFloat(d.vtacantidad||0), devuelto:parseFloat(cantDev[i]||0) })).filter(d=>d.devuelto>0);
      if(!detalle.length){setMsgErr('Ingresa al menos una cantidad a devolver');return;}
    } else {
      detalle=itemsMasivo.filter(x=>x.medcod&&x.cantidad).map(x=>({ medcod:x.medcod, regSan:x.regSan, lote:x.lote, fechaVenc:x.fechaVenc||null, cantidad:parseFloat(x.cantidad), devuelto:parseFloat(x.cantidad) }));
      if(!detalle.length){setMsgErr('Agrega al menos un medicamento');return;}
    }
    if(detalle.some(d=>!Number.isFinite(d.devuelto)||d.devuelto<=0||d.devuelto>d.cantidad)){setMsgErr('La cantidad devuelta debe ser positiva y no superar la dispensada.');return;}
    guardandoRef.current=true; setGuardando(true); setMsgErr(''); setMsgOk('');
    try {
      const r=await api.post('/farmacia/devoluciondosis/registrar',{ fdcFecha, fdcHora:fdcHora+':00', fdcQf:userName, fdcServicio, fdcDni:fdcDni||'00000000', fdcPaciente:fdcPaciente||(modo==='MASIVO'?'DEVOLUCION POR GRUPOS':''), fdcFp:modo==='MASIVO'?'GUIA':fdcFp, fdcSerieIn:modo==='RECETA'?fdcSerie:null, fdcCorrelativoIn:modo==='RECETA'?fdcCorrel:null, fdcFechaDev, fdcHoraDev:fdcHoraDev+':00', usuario:user?.usuario||'SYS', hostname:hostName, idEstablecimiento:idEst, detalle });
      if(r.data.success){ setMsgOk(`Devolución registrada: ${r.data.serie}-${r.data.correlativo}`); resetForm(); }
      else setMsgErr(r.data.message||'Error al registrar');
    } catch(e){ setMsgErr(e?.response?.data?.message||'Error al guardar'); }
    finally{ setGuardando(false); guardandoRef.current=false; }
  };

  const resetForm = () => {
    ++detailRequest.current;setCargandoDet(false);
    setFdcFecha(hoy()); setFdcHora(horaActual()); setFdcServicio(''); setFdcDni(''); setFdcPaciente('');
    setFdcFp('GUIA'); setFdcSerie(''); setFdcCorrel(''); setFdcFechaDev(hoy()); setFdcHoraDev(horaActual());
    setRecetaSel(null); setDetReceta([]); setCantDev({});
    setItemsMasivo([{id:Date.now(),medcod:'',producto:'',regSan:'',lote:'',fechaVenc:'',cantidad:''}]);
  };

  const abrirEdicion = async (fila) => {
    setEditItem(fila); setEditCab(null); setEditDet([]); setMsgOkEdit(''); setMsgErrEdit(''); setCargandoEdit(true);
    try {
      const [rCab,rDet]=await Promise.all([
        api.get('/farmacia/devoluciondosis/detalle-cab',{params:{fdcId:fila.fdc_id}}),
        api.get('/farmacia/devoluciondosis/detalle-det',{params:{fdcId:fila.fdc_id}}),
      ]);
      if(rCab.data.success) setEditCab(rCab.data.data);
      setEditDet((rDet.data.data||[]).map(d=>({ ...d, fechaVencInput:d.fechaVenc?(()=>{const p=d.fechaVenc.split('/');return p.length===3?`${p[2]}-${p[1]}-${p[0]}`:''})():'' })));
    } catch(e){setMsgErrEdit(e.response?.data?.message||'No se pudo cargar la devolución.');setScreenError(e.response?.data?.message||'No se pudo cargar la devolución.');} finally{setCargandoEdit(false);}
  };

  const abrirPendientes = async () => {
    if(!editCab) return;
    setModalPendientes(true); setPendientes([]); setCantPend({}); setCargPend(true);
    try {
      const r = await api.get('/farmacia/devoluciondosis/pendientes-receta', { params: { dni:editCab.fdcDni||null, paciente:editCab.fdcPaciente||null, comprobante:editCab.fdcSerie&&editCab.fdcCorrelativo?`${editCab.fdcSerie}-${editCab.fdcCorrelativo}`:null } });
      const items = r.data.data||[]; setPendientes(items);
      const init = {}; items.forEach((_,i)=>{ init[i]=''; }); setCantPend(init);
    } catch(e){setScreenError(e.response?.data?.message||'No se pudieron cargar los medicamentos pendientes.');} finally{setCargPend(false);}
  };

  const agregarPendientes = () => {
    const nuevos = pendientes.map((p,i)=>({ fddId:null, fddMedcod:p.medcod, producto:p.producto, fddRegSan:p.medregsan||'', fddLote:p.medlote||'', fechaVenc:p.medfecvto||'', fechaVencInput:p.medfecvto?p.medfecvto.split('T')[0]:'', fddCantidad:p.cantidadPendiente, fddDevuelto:parseFloat(cantPend[i])||0 })).filter(d=>d.fddDevuelto>0);
    if(!nuevos.length) return;
    setEditDet(prev=>[...prev,...nuevos]);
    setModalPendientes(false);
  };

  const guardarEdicion = async () => {
    if(!puedeEditar||guardandoEditRef.current||!editCab) return;
    guardandoEditRef.current=true; setGuardandoEdit(true); setMsgErrEdit(''); setMsgOkEdit('');
    try {
      const detalle=editDet.map(d=>({ medcod:d.fddMedcod, regSan:d.fddRegSan||'', lote:d.fddLote||'', fechaVenc:d.fechaVencInput||null, cantidad:parseFloat(d.fddCantidad)||0, devuelto:parseFloat(d.fddDevuelto)||0 }));
      const r=await api.post('/farmacia/devoluciondosis/actualizar',{ fdcId:editCab.fdcId, fdcFecha:editCab.fdcFecha, fdcHora:editCab.fdcHora.length===5?editCab.fdcHora+':00':editCab.fdcHora, fdcQf:editCab.fdcQf, fdcServicio:editCab.fdcServicio, fdcDni:editCab.fdcDni||'00000000', fdcPaciente:editCab.fdcPaciente||'', fdcFp:editCab.fdcFp, fdcSerie:editCab.fdcSerie||'', fdcCorrelativo:editCab.fdcCorrelativo||'', fdcFechaDev:editCab.fdcFechaDev, fdcHoraDev:editCab.fdcHoraDev.length===5?editCab.fdcHoraDev+':00':editCab.fdcHoraDev, usuario:user?.usuario||'SYS', detalle });
      if(r.data.success){ setMsgOkEdit('Actualizado correctamente'); setTimeout(()=>{ setEditItem(null); setGuardandoEdit(false); guardandoEditRef.current=false; cargarHistorial(); },1500); }
      else {setMsgErrEdit(r.data.message||'Error al actualizar');setGuardandoEdit(false);guardandoEditRef.current=false;}
    } catch(e){ setMsgErrEdit(e?.response?.data?.message||'Error'); setGuardandoEdit(false); guardandoEditRef.current=false; }
  };

  const cargarHistorial = async () => {
    if(hFechaIni>hFechaFin){setScreenError('La fecha inicial no puede ser posterior a la final.');return;}
    setScreenError('');setCargandoH(true); setHistorial([]);
    try {
      const r=await api.get('/farmacia/devoluciondosis/listar',{ params:{ fechaInicio:hFechaIni, fechaFin:hFechaFin, estado:hEstado||null, servicio:hServicio||null, buscar:hBuscar||null, idEstablecimiento:idEst } });
      setHistorial(r.data.data||[]);
    } catch(e){setScreenError(e.response?.data?.message||'No se pudo cargar el historial.');} finally{setCargandoH(false);}
  };

  useEffect(()=>{ if(tab===1) cargarHistorial(); },[tab]);

  const eliminar = async () => {
    if(!puedeEliminar||!modalDel||eliminando) return; setEliminando(true);
    try { await api.post('/farmacia/devoluciondosis/eliminar',{fdcId:modalDel.fdc_id,usuario:user?.usuario}); setModalDel(null); cargarHistorial(); }
    catch(e){setScreenError(e.response?.data?.message||'No se pudo eliminar la devolución.');} finally{setEliminando(false);}
  };

  // ── PDF helpers ───────────────────────────────────────────────────────────
  const closePdf = () => {
    setPdfModal(false);
    if(pdfUrl){ URL.revokeObjectURL(pdfUrl); setPdfUrl(null); }
  };

  const abrirSelector = (tipo, fila = null) => {
    setSelTipo(tipo);
    setSelFilaData(fila);
    setSelModal(true);
  };

  const verPdfIndividual = async (fila) => {
    setSelModal(false);
    setPdfUrl(null); setPdfCargando(true); setPdfModal(true);
    setPdfTitulo('Devolución de Medicamentos');
    setPdfSubtitulo(`${fila.documento}  ·  ${fila.fdc_paciente||'-'}`);
    setPdfFrameId(`dev-ind-pdf-${fila.fdc_id}`);
    try {
      const rDet = await api.get('/farmacia/devoluciondosis/detalle-det',{params:{fdcId:fila.fdc_id}});
      const det  = rDet.data.data||[];
      const payload = { documento:fila.documento, paciente:fila.fdc_paciente, dni:fila.fdc_dni, comprobante:fila.documento, formaPago:fila.fdc_fp, servicio:fila.fdc_servicio, qf:userName, detalle:det.map(d=>({ medcod:d.fddMedcod, producto:d.producto, regSan:d.fddRegSan, lote:d.fddLote, fechaVenc:d.fechaVenc, devuelto:parseFloat(d.fddDevuelto)||0 })) };
      const r = await api.post('/farmacia/devoluciondosis/exportar-pdf-individual', payload, {responseType:'blob'});
      setPdfUrl(URL.createObjectURL(new Blob([r.data],{type:'application/pdf'})));
    } catch(e){ console.error(e); closePdf(); }
    finally{ setPdfCargando(false); }
  };

  const descargarExcelIndividual = async (fila) => {
    setSelExportando(true);
    try {
      const rDet = await api.get('/farmacia/devoluciondosis/detalle-det',{params:{fdcId:fila.fdc_id}});
      const det  = rDet.data.data||[];
      const payload = { documento:fila.documento, paciente:fila.fdc_paciente, dni:fila.fdc_dni, comprobante:fila.documento, formaPago:fila.fdc_fp, servicio:fila.fdc_servicio, qf:userName, detalle:det.map(d=>({ medcod:d.fddMedcod, producto:d.producto, regSan:d.fddRegSan, lote:d.fddLote, fechaVenc:d.fechaVenc, devuelto:parseFloat(d.fddDevuelto)||0 })) };
      const r = await api.post('/farmacia/devoluciondosis/exportar-excel-individual', payload, {responseType:'blob'});
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([r.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
      a.download = `Devolucion_${fila.documento?.replace('-','_')}.xlsx`; a.click(); URL.revokeObjectURL(a.href);
      setSelModal(false);
    } catch(e){ console.error(e); }
    finally{ setSelExportando(false); }
  };

  const verPdfConsolidado = async () => {
    setSelModal(false);
    if(!historial.length) return;
    setPdfUrl(null); setPdfCargando(true); setPdfModal(true);
    setPdfTitulo('Consolidado de Devoluciones');
    setPdfSubtitulo(`${hFechaIni}  —  ${hFechaFin}${hServicio ? '  ·  '+hServicio : ''}`);
    setPdfFrameId('dev-consol-pdf');
    try {
      const rItems = await api.get('/farmacia/devoluciondosis/consolidado-datos',{params:{fechaInicio:hFechaIni,fechaFin:hFechaFin,servicio:hServicio||null,idEstablecimiento:idEst}});
      const r = await api.post('/farmacia/devoluciondosis/exportar-pdf-consolidado',{ desde:hFechaIni, hasta:hFechaFin, servicio:hServicio||'', items:rItems.data.data||[] },{responseType:'blob'});
      setPdfUrl(URL.createObjectURL(new Blob([r.data],{type:'application/pdf'})));
    } catch(e){ console.error(e); closePdf(); }
    finally{ setPdfCargando(false); }
  };

  const descargarExcelConsolidado = async () => {
    setSelExportando(true);
    try {
      const rItems = await api.get('/farmacia/devoluciondosis/consolidado-datos',{params:{fechaInicio:hFechaIni,fechaFin:hFechaFin,servicio:hServicio||null,idEstablecimiento:idEst}});
      const r = await api.post('/farmacia/devoluciondosis/exportar-excel-consolidado',{ desde:hFechaIni, hasta:hFechaFin, servicio:hServicio||'', items:rItems.data.data||[] },{responseType:'blob'});
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([r.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
      a.download = `Consolidado_${hFechaIni}_${hFechaFin}.xlsx`; a.click(); URL.revokeObjectURL(a.href);
      setSelModal(false);
    } catch(e){ console.error(e); }
    finally{ setSelExportando(false); }
  };

  // ── Funciones Tab Indicadores ─────────────────────────────────────────
  const resetFormIndicadores = () => {
  setITabla([]);
  setIConsultado(false);
  setIMsgOk('');
  setIMsgErr('');
  setIhRegistroMarcado(null);
  // ← resetear todos los campos del formulario
  setIDispDosis('SI');
  setITotalCamas('');
  setICamas('');
  setIChkA(false);
  setIChkE(false);
  setIChkI(false);
  setIChkS(false);
  setIChkH(false);
  setIChkU(false);
  setISegIH('SI');
  setISegIHPac('');
  setISegAmb('SI');
  setISegAmbPac('');
  setIQfSdmdu('');
  setIQfSft('');
  setIQfDisp('');
  setIQfDispEsp('');
  setISftB1('');
  setISftA1(''); setISftA2(''); setISftA3(''); setISftA4(''); setIErroresDisp('');
  setIServConsultado('');
};

const consultarIndicadores = async () => {
  resetFormIndicadores(); // ← llamala acá
  setICargando(true);
  try {
    // ← PRIMERO verificar si ya existe
    const existe = await api.get('/farmacia/devoluciondosis/indicadores-existe', {
      params: { mes: iMes, anio: iAnio, idEstablecimiento: idEst, servicio: iServicio }
    });

    if (existe.data.existe) {
      // Ir al historial y marcar el registro
      setIhRegistroMarcado(existe.data.fdcId);
      setISubTab(1);
      await cargarHistorialInd();
      setIMsgErr(''); 
      return; // no consultar más
    }

    // Si no existe, consultar normal
    const r = await api.get('/farmacia/devoluciondosis/indicadores-consulta', {
      params: { mes: iMes, anio: iAnio, idEstablecimiento: idEst, servicio: iServicio }
    });
    setITabla(r.data.data || []);
    setIConsultado(true);
    setIServConsultado(iServicio);   // ← congela el servicio consultado
  } catch { setIMsgErr('Error al consultar'); }
  finally { setICargando(false); }
};

  const guardarIndicadores = async () => {
    if(!puedeEditar)return;
    if (!iConsultado || !iTabla.length) { setIMsgErr('Primero consulta el periodo'); return; }
    setIGuardando(true); setIMsgOk(''); setIMsgErr('');
    try {
      const r = await api.post('/farmacia/devoluciondosis/indicadores-guardar', {
        mes: iMes, anio: iAnio, servicio: iServConsultado,
        dispDosis: iDispDosis, totalCamas: parseInt(iTotalCamas)||0,
        camas: parseInt(iCamas)||0,
        servicioA: iChkA, servicioE: iChkE, servicioI: iChkI,
        servicioS: iChkS, servicioH: iChkH, servicioU: iChkU,
        segInterHosp: iSegIH, segIHNPac: parseInt(iSegIHPac)||0,
        segAmb: iSegAmb, segAmbNPac: parseInt(iSegAmbPac)||0,
        cantQfSdmdu: parseInt(iQfSdmdu)||0, cantQfSft: parseInt(iQfSft)||0,
        cantQfDisp: parseInt(iQfDisp)||0, cantQfDispEsp: parseInt(iQfDispEsp)||0,
        sftB1: parseInt(iSftB1)||0,
        sftA1: parseInt(iSftA1)||0, sftA2: parseInt(iSftA2)||0,
        sftA3: parseInt(iSftA3)||0, sftA4: parseInt(iSftA4)||0,
        sftB3: parseInt(iSftB3)||0,
        erroresDisp: parseInt(iErroresDisp)||0,
        idEstablecimiento: idEst,
      });
      if (r.data.success) {
        setIServReg(prev=>[...prev, iServicio]);
  setIConsultado(false);
  setITabla([]);
  setIhRegistroMarcado(r.data.idCab); // ← marca el registro
  setISubTab(1);                       // ← va al historial
  await cargarHistorialInd();          // ← carga el historial
}
      else setIMsgErr(r.data.message || 'Error al guardar');
    } catch(e) { setIMsgErr(e?.response?.data?.message || 'Error'); }
    finally { setIGuardando(false); }
  };

  const cargarHistorialInd = async () => {
    setIhCargando(true); setIhLista([]);
    try {
      const r = await api.get('/farmacia/devoluciondosis/indicadores-listar', {
        params: { idEstablecimiento: idEst, anio: ihAnio||null, mes: ihMes||null }
      });
      setIhLista(r.data.data || []);
    } catch(e) {setScreenError(e.response?.data?.message||'No se pudo cargar el historial de indicadores.');} finally { setIhCargando(false); }
  };

  const verIndicador = async (item) => {
    try {
      const r = await api.get('/farmacia/devoluciondosis/indicadores-detalle',
        { params: { fdcId: item.fdcId } });
      if (r.data.success) setIhVerItem({ ...r.data.cab, det: r.data.det });
    } catch {}
  };

  const eliminarIndicador = async () => {
    if(!puedeEliminar)return;
    if (!ihDelItem) return;
    setIhEliminando(true);
    try {
      await api.post('/farmacia/devoluciondosis/indicadores-eliminar',
        { fdcId: ihDelItem.fdcId, usuario: user?.usuario });
      setIServReg(prev=>prev.filter(s=>s!==ihDelItem.servicio || ihDelItem.mes!==iMes || ihDelItem.anio!==iAnio));
      setIhDelItem(null); cargarHistorialInd();
    } catch(e) {setScreenError(e.response?.data?.message||'No se pudo eliminar el indicador.');} finally { setIhEliminando(false); }
  };

  // ── Función imprimir indicador ────────────────────────────────────────
const imprimirIndicador = async (h) => {
  try {
    // 1. Traer datos del SP
    const r = await api.get('/farmacia/devoluciondosis/indicadores-imprimir-datos', {
        params: { fdcId: h.fdcId, mes: h.mes, anio: h.anio, servicio: h.servicio }
    });
    if (!r.data.success) return;
    const d = r.data.data;

    // 2. Generar PDF
    const pdf = await api.post(
      '/farmacia/devoluciondosis/exportar-pdf-indicadores', d,
      { responseType: 'blob' }
    );

    // 3. Abrir en visor
    setPdfUrl(URL.createObjectURL(new Blob([pdf.data], { type: 'application/pdf' })));
    setPdfTitulo('Indicadores SDMDU');
    setPdfSubtitulo(`${MESES[h.mes-1]} ${h.anio}`);
    setPdfFrameId(`ind-pdf-${h.fdcId}`);
    setPdfModal(true);
  } catch(e) { console.error(e); }
};

const imprimirConsolidado = async () => {
    if (cHasta < cDesde) { alert('El mes final no puede ser menor al inicial'); return; }
    setModalConsol(false);
    try {
      const r = await api.get('/farmacia/devoluciondosis/indicadores-imprimir-consolidado', {
        params: { anio: cAnio, mesInicio: cDesde, mesFin: cHasta, idEstablecimiento: idEst }
      });
      if (!r.data.success) { alert(r.data.message||'Sin indicadores guardados en ese rango'); return; }
      const pdf = await api.post('/farmacia/devoluciondosis/exportar-pdf-indicadores',
        r.data.data, { responseType:'blob' });
      setPdfUrl(URL.createObjectURL(new Blob([pdf.data],{type:'application/pdf'})));
      setPdfTitulo('Indicadores SDMDU — Consolidado');
      setPdfSubtitulo(cDesde===cHasta ? `${MESES[cDesde-1]} ${cAnio}` : `${MESES[cDesde-1]} — ${MESES[cHasta-1]} ${cAnio}`);
      setPdfFrameId('ind-pdf-consolidado');
      setPdfModal(true);
    } catch(e){ console.error(e); }
  };

  const pct = (a, b) => b > 0 ? ((a / b) * 100).toFixed(2) + '%' : '—';

  const histPaginado = historial.slice((pagH-1)*filasH, pagH*filasH);

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <>
      <Box className="devoluciones-page pharmacy-page" sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
        <HeaderIOS titulo="Devolución Dosis" subtitulo="Farmacia"
          onHome={()=>navigate('/farmacia')} onLogout={handleLogout}
          nombreCompleto={user?.nombreCompleto||user?.usuario||''}
          avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

        <Box className="pharmacy-content" sx={{ maxWidth:1600, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2, pb:6 }}>
          {/* Tabs — reemplazá el bloque de tabs existente */}
          <Box className="pharmacy-inline-tabs"><PharmacyTabs value={tab} onChange={i=>{setTab(i);if(i===2)cargarHistorialInd();}} options={['Registro','Historial','Indicadores']}/></Box>

          <section className="devoluciones-heading"><span>Devoluciones · Farmacia</span><h1>{['Cada devolución, en orden','La historia de cada devolución','Tu servicio, en perspectiva'][tab]}</h1><p>{['Registra los medicamentos devueltos por receta o por guía.','Consulta, revisa y descarga las devoluciones de tu establecimiento.','Revisa la actividad mensual y los indicadores de dosis unitaria.'][tab]}</p></section>
          <Snackbar open={Boolean(screenError)} anchorOrigin={{vertical:'bottom',horizontal:'center'}} sx={{zIndex:15000,maxWidth:'calc(100vw - 32px)'}}><Alert severity="error" onClose={()=>setScreenError('')} sx={{borderRadius:3,boxShadow:'0 8px 24px #20314a22'}}>{screenError}</Alert></Snackbar>
          {!puedeEditar&&<Alert severity="info" sx={{mb:2,borderRadius:3}}>Vista de consulta. Necesitas permiso de escritura para registrar o modificar devoluciones.</Alert>}
          {/* ══ TAB 0: REGISTRO ══ */}
          {tab===0 && (
            <Box>
              <Card mb={2}>
                <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:2, flexWrap:'wrap' }}>
                  <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Tipo:</Typography>
                  {[{v:'RECETA',label:'Por Receta'},{v:'MASIVO',label:'Masivo / Guía'}].map(opt=>(
                    <Box key={opt.v} onClick={()=>{setModo(opt.v);resetForm();}}
                      sx={{ px:2, py:0.8, borderRadius:'10px', cursor:'pointer', border:`2px solid ${modo===opt.v?IOS.blue:IOS.separator}`, bgcolor:modo===opt.v?`${IOS.blue}08`:IOS.surface, transition:'all 0.15s' }}>
                      <Typography sx={{ fontSize:'0.82rem', fontWeight:modo===opt.v?700:500, color:modo===opt.v?IOS.blue:IOS.label2 }}>{opt.label}</Typography>
                    </Box>
                  ))}
                </Box>
              </Card>

              <Card mb={2}>
                <Typography sx={{ fontSize:'0.72rem', fontWeight:700, color:IOS.label, mb:1.8, pb:1, borderBottom:`1px solid ${IOS.separator}` }}>Datos del documento</Typography>
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{xs:'minmax(0,1fr)',sm:'repeat(2,minmax(0,1fr))',lg:'repeat(4,minmax(0,1fr))'}, gap:1.5 }}>
                  {modo==='RECETA' && <>
                    <Box><Lbl>Fecha receta</Lbl><Inp type="date" value={fdcFecha} readOnly blue/></Box>
                    <Box><Lbl>Hora receta</Lbl><Inp type="time" value={fdcHora} readOnly blue/></Box>
                    <Box><Lbl>Fecha devolución</Lbl><DatePickerIOS value={fdcFechaDev} onChange={setFdcFechaDev} /></Box>
                    <Box><Lbl>Hora devolución</Lbl><Inp type="time" value={fdcHoraDev} onChange={e=>setFdcHoraDev(e.target.value)}/></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 2'} }}><Lbl>Servicio *</Lbl><Sel value={fdcServicio} onChange={e=>setFdcServicio(e.target.value)}><option value="">— Selecciona servicio —</option>{SERVICIOS.map(s=><option key={s} value={s}>{s}</option>)}</Sel></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 2'} }}><Lbl>Q.F. Responsable</Lbl><Inp value={userName} readOnly/></Box>
                    <Box><Lbl>F. Pago</Lbl><Inp value={fdcFp} readOnly blue placeholder="— de la receta —"/></Box>
                    <Box><Lbl>Serie</Lbl><Inp value={fdcSerie} readOnly blue mono placeholder="—"/></Box>
                    <Box><Lbl>Correlativo</Lbl><Inp value={fdcCorrel} readOnly blue mono placeholder="—"/></Box>
                    <Box><Lbl>DNI</Lbl><Inp value={fdcDni} readOnly blue mono placeholder="—"/></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 3'} }}><Lbl>Paciente</Lbl><Inp value={fdcPaciente} readOnly blue placeholder="—"/></Box>
                  </>}
                  {modo==='MASIVO' && <>
                    <Box><Lbl>Fecha</Lbl><DatePickerIOS value={fdcFecha} onChange={v=>{ setFdcFecha(v); setFdcFechaDev(v); }} /></Box>
                    <Box><Lbl>Hora</Lbl><Inp type="time" value={fdcHora} onChange={e=>{ setFdcHora(e.target.value); setFdcHoraDev(e.target.value); }}/></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 2'} }}><Lbl>Servicio *</Lbl><Sel value={fdcServicio} onChange={e=>setFdcServicio(e.target.value)}><option value="">— Selecciona servicio —</option>{SERVICIOS.map(s=><option key={s} value={s}>{s}</option>)}</Sel></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 2'} }}><Lbl>Q.F. Responsable</Lbl><Inp value={userName} readOnly/></Box>
                    <Box sx={{ gridColumn:{xs:'span 1',sm:'span 2',lg:'span 4'} }}><Lbl>Descripción / Referencia</Lbl><Inp value={fdcPaciente} onChange={e=>setFdcPaciente(e.target.value)} placeholder="Ej: DEVOLUCION POR GRUPOS"/></Box>
                  </>}
                </Box>
              </Card>

              {/* MODO RECETA */}
              {modo==='RECETA' && (
                <Card p={0} mb={2}>
                  <Box sx={{ p:2, borderBottom:`1px solid ${IOS.separator}`, bgcolor:IOS.bg, borderRadius:'16px 16px 0 0' }}>
                    <Typography sx={{ fontSize:'0.78rem', fontWeight:700, color:IOS.label, mb:1.5 }}>Buscar receta</Typography>
                    <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, flexWrap:'wrap', alignItems:'flex-end' }}>
                      <Box sx={{ flex:{ xs:'1 1 100%', sm:'0 0 220px' } }}><Lbl>IPRESS</Lbl><Sel value={filtroIpress} onChange={e=>setFiltroIpress(e.target.value)}>{ipressList.map(ip=><option key={`${ip.id}-${ip.nombre}`} value={ip.id}>{ip.nombre}</option>)}</Sel></Box>
                      <Box sx={{ flex:{ xs:'1 1 calc(50% - 6px)', sm:'0 0 140px' } }}><Lbl>Fecha inicio</Lbl><DatePickerIOS value={filtroFechaIni} onChange={setFiltroFechaIni} /></Box>
                      <Box sx={{ flex:{ xs:'1 1 calc(50% - 6px)', sm:'0 0 140px' } }}><Lbl>Fecha fin</Lbl><DatePickerIOS value={filtroFechaFin} onChange={setFiltroFechaFin} /></Box>
                      <Box sx={{ flex:{ xs:'1 1 calc(50% - 6px)', sm:'0 0 120px' } }}><Lbl>DNI</Lbl><Inp value={filtroDni} onChange={e=>setFiltroDni(e.target.value)} placeholder="DNI..." /></Box>
                      <Box sx={{ flex:{ xs:'1 1 calc(50% - 6px)', sm:'0 0 160px' } }}><Lbl>Paciente</Lbl><Inp value={filtroPaciente} onChange={e=>setFiltroPaciente(e.target.value)} placeholder="Nombre..." /></Box>
                      <Box className="pharmacy-layout pharmacy-action" component="button" onClick={buscarRecetas} disabled={buscandoRec}
                        sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:IOS.blue, cursor:buscandoRec?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:0.8, alignSelf:'flex-end', width:{ xs:'100%', sm:'auto' }, transition:'all 0.15s', '&:hover':{ filter:'brightness(0.92)' } }}>
                        {buscandoRec?<CircularProgress size={13} sx={{ color:'white' }} />:null}
                        <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>{buscandoRec?'Buscando...':'Buscar'}</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:{ xs:'column', md:'row' }, minHeight:400 }}>
                    <Box sx={{ width:{ xs:'100%', md:320 }, flexShrink:0, borderRight:{ xs:'none', md:`1px solid ${IOS.separator}` }, borderBottom:{ xs:`1px solid ${IOS.separator}`, md:'none' }, overflowY:'auto', maxHeight:{ xs:260, md:520 }, '&::-webkit-scrollbar':{ width:3 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                      {buscandoRec
                        ?<Box sx={{ py:6, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>
                        :recetas.length===0
                          ?<Box sx={{ p:4, textAlign:'center', color:IOS.label2, fontSize:'0.8rem' }}>Busca una receta para comenzar</Box>
                          :recetas.map(rec=>{ const sel=recetaSel?.codigo===rec.codigo; return (
                            <Box key={rec.codigo} onClick={()=>cargarDetalle(rec)}
                              sx={{ px:2, py:1.5, cursor:'pointer', borderBottom:`1px solid ${IOS.separator}`, bgcolor:sel?`${IOS.blue}08`:IOS.surface, borderLeft:`3px solid ${sel?IOS.blue:'transparent'}`, '&:hover':{ bgcolor:sel?`${IOS.blue}08`:IOS.bg }, transition:'all 0.1s' }}>
                              <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:0.3 }}>
                                <Typography sx={{ fontFamily:'monospace', fontWeight:700, fontSize:'0.8rem', color:sel?IOS.blue:IOS.label }}>{rec.doc_completo}</Typography>
                                <Box sx={{ px:0.8, py:0.2, borderRadius:'20px', bgcolor:IOS.bg }}><Typography sx={{ fontSize: '0.72rem', fontWeight:600, color:IOS.label2 }}>{rec.forma_pago}</Typography></Box>
                              </Box>
                              <Typography sx={{ fontSize:'0.76rem', color:IOS.label, fontWeight:600, mb:0.2 }}>{rec.paciente}</Typography>
                              <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>{rec.vtafechreg} · {rec.ipress}</Typography>
                            </Box>
                          );})
                      }
                    </Box>
                    <Box sx={{ flex:1, overflowX:'auto', minWidth:0 }}>
                      {!recetaSel&&!cargandoDet&&(
                        <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', gap:1.5, p:4 }}>
                          <svg width="40" height="40" viewBox="0 0 24 24" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke={IOS.separator} strokeWidth="1.5"/><polyline points="14 2 14 8 20 8" stroke={IOS.separator} strokeWidth="1.5"/><line x1="16" y1="13" x2="8" y2="13" stroke={IOS.separator} strokeWidth="1.5"/></svg>
                          <Typography sx={{ fontSize:'0.82rem', color:IOS.label2 }}>Selecciona una receta para ver su detalle</Typography>
                        </Box>
                      )}
                      {cargandoDet&&<Box sx={{ py:8, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}
                      {recetaSel&&!cargandoDet&&(
                        <Box>
                          <Box className="pharmacy-layout" sx={{ px:{ xs:1.5, sm:2.5 }, py:1.5, bgcolor:`${IOS.blue}08`, borderBottom:`1px solid ${IOS.blue}20`, display:'flex', flexWrap:'wrap', gap:1.5, alignItems:'center' }}>
                            {[['PACIENTE',recetaSel.paciente,IOS.blue],['DNI',recetaSel.dni_clie||'-',IOS.label],['DOCUMENTO',recetaSel.doc_completo,IOS.blue],['F.PAGO',recetaSel.forma_pago,IOS.label],['FECHA',recetaSel.vtafechreg||'-',IOS.label]].map(([k,v,c])=>(
                              <Box key={k}><Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em' }}>{k}</Typography><Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:c, fontFamily:k==='DNI'||k==='DOCUMENTO'?'monospace':'inherit' }}>{v}</Typography></Box>
                            ))}
                          </Box>
                          {detReceta.length===0
                            ?<Box sx={{ p:4, textAlign:'center', color:IOS.label2, fontSize:'0.82rem' }}>Sin ítems en esta receta</Box>
                            :<table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.78rem' }}>
                              <thead><tr><TH>#</TH><TH>Producto</TH><TH>Lote</TH><TH>F. Venc</TH><TH center>Dispensado</TH><TH center>Devolver</TH></tr></thead>
                              <tbody>{detReceta.map((d,i)=>(
                                <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:cantDev[i]?'#EDFAF2':i%2===0?IOS.surface:IOS.bg }}>
                                  <td style={{ padding:'8px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{d.vtaitem}</td>
                                  <td style={{ padding:'8px 10px', maxWidth:260 }}>
                                    <Typography sx={{ fontSize:'0.78rem', fontWeight:600, color:IOS.label }}>{d.producto}</Typography>
                                    <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontFamily:'monospace' }}>{d.medregsan}</Typography>
                                  </td>
                                  <td style={{ padding:'8px 10px', color:IOS.label2, fontFamily:'monospace', fontSize:'0.7rem' }}>{d.medlote||'-'}</td>
                                  <td style={{ padding:'8px 10px', color:IOS.label2, fontFamily:'monospace', fontSize:'0.7rem' }}>{fmtFecha(d.medfecvto)}</td>
                                  <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700, color:IOS.label }}>{d.vtacantidad}</td>
                                  <td style={{ padding:'5px 8px', textAlign:'center', minWidth:100 }}>
                                    <input type="number" min="0" max={d.vtacantidad} placeholder="0" value={cantDev[i]||''}
                                      onChange={e=>{const v=parseFloat(e.target.value);const max=parseFloat(d.vtacantidad)||0; setCantDev(prev=>({...prev,[i]:(!e.target.value||v<=max)?e.target.value:String(max)}));}}
                                      style={{ width:80, height:32, padding:'0 8px', border:`2px solid ${cantDev[i]?IOS.blue:IOS.separator}`, borderRadius:8, fontSize:'0.88rem', textAlign:'center', outline:'none', backgroundColor:cantDev[i]?`${IOS.blue}08`:IOS.surface, color:IOS.label, fontWeight:cantDev[i]?700:400 }} />
                                  </td>
                                 </tr>
                              ))}</tbody>
                             </table>
                          }
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Card>
              )}

              {/* MODO MASIVO */}
              {modo==='MASIVO' && (
                <Card mb={2}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1.8, pb:1, borderBottom:`1px solid ${IOS.separator}` }}>
                    <Typography sx={{ fontSize:'0.78rem', fontWeight:700, color:IOS.label }}>Medicamentos a devolver</Typography>
                    <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1 }}>
                      <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0' }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#8B6914' }}>Guía autogenerada</Typography>
                      </Box>
                      <Tooltip title="Agregar fila" placement="top">
                        <Box className="pharmacy-layout" onClick={addFila} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:IOS.blue, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                  <Box sx={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.78rem' }}>
                      <thead>
  <tr>
    <TH>Producto</TH>
    <TH>Reg. San.</TH>
    <TH>Lote</TH>
    <TH>F. Venc</TH>
    <TH center>Cantidad</TH>
    <TH></TH>
  </tr>
</thead>
                      <tbody>
                        {itemsMasivo.map((item)=>(
                          <tr key={item.id} style={{ borderBottom:`1px solid ${IOS.separator}` }}>
                            <td style={{ padding:'5px 8px', minWidth:260 }}>
                              <Box className="pharmacy-layout" onClick={()=>{setFilaModal(item.id);setModalProd(true);}}
                                sx={{width:'100%',height:32,px:1,display:'flex',alignItems:'center',gap:1,border:`1px solid ${item.medcod?IOS.blue:IOS.separator}`,borderRadius:8,bgcolor:item.medcod?`${IOS.blue}04`:IOS.surface,cursor:'pointer','&:hover':{borderColor:IOS.blue,bgcolor:`${IOS.blue}06`},transition:'all 0.15s'}}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={item.medcod?IOS.blue:IOS.label2} strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                                <Typography sx={{fontSize:'0.76rem',color:item.medcod?IOS.label:IOS.label2,flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.producto||'Buscar producto...'}</Typography>
                                {item.medcod&&<Typography sx={{fontSize: '0.72rem',color:IOS.blue,fontFamily:'monospace',flexShrink:0}}>{item.medcod}</Typography>}
                              </Box>
                             </td>
                            <td style={{ padding:'5px 8px', minWidth:110 }}><input value={item.regSan} onChange={e=>updateFila(item.id,'regSan',e.target.value)} placeholder="RS..." style={{ width:'100%', height:32, padding:'0 8px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', color:IOS.label, fontFamily:'monospace', backgroundColor:IOS.surface }} /></td>
                            <td style={{ padding:'5px 8px', minWidth:100 }}><input value={item.lote} onChange={e=>updateFila(item.id,'lote',e.target.value)} placeholder="Lote..." style={{ width:'100%', height:32, padding:'0 8px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', color:IOS.label, fontFamily:'monospace', backgroundColor:IOS.surface }} /></td>
                            <td style={{ padding:'5px 8px', minWidth:130 }}><input type="date" value={item.fechaVenc} onChange={e=>updateFila(item.id,'fechaVenc',e.target.value)} style={{ width:'100%', height:32, padding:'0 8px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', color:IOS.label, backgroundColor:IOS.surface }} /></td>
                            <td style={{ padding:'5px 8px', minWidth:90, textAlign:'center' }}>
                              <input id={`cant-${item.id}`} type="number" min="0" value={dispCant(item.cantidad)} onChange={e=>updateFila(item.id,'cantidad',e.target.value)} placeholder="0"
                                onKeyDown={e=>{
                                  if(e.key==='Enter'||e.key==='Tab'){
                                    e.preventDefault();
                                    const idx = itemsMasivo.findIndex(x=>x.id===item.id);
                                    if(idx===itemsMasivo.length-1){ const nuevoId = Date.now(); setItemsMasivo(prev=>[...prev,{id:nuevoId,medcod:'',producto:'',regSan:'',lote:'',fechaVenc:'',cantidad:''}]); setTimeout(()=>setFilaModal(nuevoId)||setModalProd(true),50); }
                                    else { setFilaModal(itemsMasivo[idx+1].id); setModalProd(true); }
                                  }
                                }}
                                style={{ width:'100%', height:32, padding:'0 8px', border:`1px solid ${item.cantidad?`${IOS.blue}50`:IOS.separator}`, borderRadius:8, fontSize:'0.82rem', outline:'none', boxSizing:'border-box', backgroundColor:item.cantidad?`${IOS.blue}08`:IOS.surface, color:IOS.label, textAlign:'center' }} />
                             </td>
                            <td style={{ padding:'5px 8px', textAlign:'center', width:36 }}>
                              {itemsMasivo.length>1&&(
                                <Box onClick={()=>removeFila(item.id)} sx={{ width:26, height:26, borderRadius:'50%', bgcolor:'#FFF0EF', display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer', '&:hover':{ bgcolor:'#FFD4D1' } }}>
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                                </Box>
                              )}
                             </td>
                           </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </Card>
              )}

              {(msgOk||msgErr) && (
                <Box sx={{ mb:2, p:1.5, borderRadius:'12px', bgcolor:msgOk?'#EDFAF2':'#FFF0EF', border:`1px solid ${msgOk?'#B7EFD0':'#FFD4D1'}` }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1 }}>
                    <Box sx={{ width:6, height:6, borderRadius:'50%', bgcolor:msgOk?IOS.green:IOS.red, flexShrink:0 }} />
                    <Typography sx={{ fontSize:'0.82rem', fontWeight:600, color:msgOk?'#1A6B3C':'#C0392B' }}>{msgOk||msgErr}</Typography>
                  </Box>
                </Box>
              )}
              <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'flex-end', gap:1.5 }}>
                <Box className="pharmacy-action" component="button" onClick={resetForm} sx={{ height:36, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`, bgcolor:IOS.surface, cursor:'pointer', fontSize:'0.8rem', fontWeight:600, color:IOS.label2 }}>Limpiar</Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={guardar} disabled={!puedeEditar||cargandoDet||guardando||!fdcServicio||(modo==='RECETA'&&!recetaSel)}
                  sx={{ height:36, px:3, borderRadius:'10px', border:'none', bgcolor:guardando||!fdcServicio||(modo==='RECETA'&&!recetaSel)?'#E5E5EA':IOS.blue, cursor:guardando||!fdcServicio||(modo==='RECETA'&&!recetaSel)?'default':'pointer', display:'flex', alignItems:'center', gap:0.8, transition:'all 0.15s', '&:hover':{ filter:'brightness(0.92)' } }}>
                  {guardando&&<CircularProgress size={13} sx={{ color:'white' }} />}
                  <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:guardando||!fdcServicio||(modo==='RECETA'&&!recetaSel)?'#8E8E93':'white' }}>{guardando?'Guardando...':'Registrar Devolución'}</Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* ══ TAB 1: HISTORIAL ══ */}
          {tab===1 && (
            <Box>
              <div className="devoluciones-metrics"><PharmacyMetric label="Devoluciones" value={cargandoH?'—':historial.length} sub="En la consulta actual" color="#548ee6"/><PharmacyMetric label="Activas" value={cargandoH?'—':historial.filter(h=>h.estado==='ACTIVO').length} sub="Disponibles para revisión" color="#58a185"/><PharmacyMetric label="Anuladas" value={cargandoH?'—':historial.filter(h=>h.estado==='ANULADO').length} sub="En la consulta actual" color="#9b83c9"/></div>
              <Card mb={2}>
                <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, flexWrap:'wrap', alignItems:'flex-end' }}>
                  <Box sx={{ width:{ xs:'calc(50% - 6px)', sm:'auto' } }}><Lbl>Fecha inicio</Lbl><DatePickerIOS value={hFechaIni} onChange={setHFechaIni} /></Box>
                  <Box sx={{ width:{ xs:'calc(50% - 6px)', sm:'auto' } }}><Lbl>Fecha fin</Lbl><DatePickerIOS value={hFechaFin} onChange={setHFechaFin} /></Box>
                  <Box sx={{ minWidth:{ xs:'calc(50% - 6px)', sm:160 } }}><Lbl>Servicio</Lbl><Sel value={hServicio} onChange={e=>setHServicio(e.target.value)}><option value="">Todos</option>{SERVICIOS.map(s=><option key={s} value={s}>{s}</option>)}</Sel></Box>
                  <Box sx={{ minWidth:{ xs:'calc(50% - 6px)', sm:130 } }}><Lbl>Estado</Lbl><Sel value={hEstado} onChange={e=>setHEstado(e.target.value)}><option value="">Todos</option><option value="1">Activo</option><option value="0">Anulado</option></Sel></Box>
                  <Box sx={{ flex:1, minWidth:{ xs:'100%', sm:180 } }}><Lbl>Buscar</Lbl><Inp value={hBuscar} onChange={e=>setHBuscar(e.target.value)} placeholder="Paciente, DNI, Nº doc..." /></Box>
                  <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cargarHistorial} disabled={cargandoH}
                    sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:IOS.blue, cursor:cargandoH?'default':'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:0.8, alignSelf:'flex-end', width:{ xs:'100%', sm:'auto' }, transition:'all 0.15s', '&:hover':{ filter:'brightness(0.92)' } }}>
                    {cargandoH?<CircularProgress size={13} sx={{ color:'white' }} />:null}
                    <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>{cargandoH?'Consultando...':'Consultar'}</Typography>
                  </Box>
                </Box>
              </Card>

              {cargandoH&&<Box sx={{ py:10, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}
              {!cargandoH&&historial.length===0&&(
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                  <Box className="pharmacy-layout" sx={{ width:56, height:56, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  </Box>
                  <Typography sx={{ fontWeight:700, color:IOS.label, mb:0.5 }}>Sin resultados</Typography>
                  <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Ajusta los filtros y consulta</Typography>
                </Box>
              )}
              {!cargandoH&&historial.length>0&&(
                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  <Box className="pharmacy-layout" sx={{ px:2.5, py:1.8, borderBottom:`1px solid ${IOS.separator}`, display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:1 }}>
                    <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, flexWrap:'wrap' }}>
                      <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>{historial.length} devoluciones</Typography>
                      <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:`${IOS.blue}12` }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>Establecimiento actual</Typography>
                      </Box>
                    </Box>
                    <Tooltip title="Exportar Consolidado" placement="top">
                      <Box className="pharmacy-layout pharmacy-action" component="button" onClick={() => abrirSelector('consolidado')} disabled={pdfCargando}
                        sx={{ width:32, height:32, borderRadius:'50%', border:'none', bgcolor:IOS.green, cursor:pdfCargando?'default':'pointer',
                          display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s', '&:hover':{ filter:'brightness(0.9)' } }}>
                        {pdfCargando
                          ?<CircularProgress size={13} sx={{ color:'white' }} />
                          :<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>}
                      </Box>
                    </Tooltip>
                  </Box>
                  {/* Móvil — cards */}
                  <Box sx={{ display:{ xs:'block', md:'none' } }}>
                    {histPaginado.map((h,idx)=>(
                      <Box key={h.fdc_id} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}` }}>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:1, mb:0.5 }}>
                          <Box sx={{ minWidth:0 }}>
                            <Typography sx={{ fontFamily:'monospace', fontWeight:700, fontSize:'0.82rem', color:IOS.blue }}>{h.documento}</Typography>
                            <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>{h.fdc_servicio}</Typography>
                          </Box>
                          <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:h.estado==='ACTIVO'?'#EDFAF2':'#FFF0EF', border:`1px solid ${h.estado==='ACTIVO'?'#B7EFD0':'#FFD4D1'}`, flexShrink:0 }}>
                            <Box sx={{ width:4, height:4, borderRadius:'50%', bgcolor:h.estado==='ACTIVO'?IOS.green:IOS.red }} />
                            <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:h.estado==='ACTIVO'?'#1A6B3C':'#C0392B' }}>{h.estado}</Typography>
                          </Box>
                        </Box>
                        <Typography sx={{ fontSize:'0.78rem', fontWeight:600, color:IOS.label, mb:0.3 }}>{h.fdc_paciente||'-'}</Typography>
                        <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontFamily:'monospace', mb:1 }}>DNI: {h.fdc_dni||'-'}</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:1.2 }}>
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Recepción: {h.fecha} {h.hora}</Typography>
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Devolución: {h.fecha_dev}</Typography>
                        </Box>
                        <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                          <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>{h.nro_medicamentos} medicamentos · {h.total_items} ítems</Typography>
                          <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.8 }}>
                            <Box onClick={()=>abrirSelector('individual', h)}
                              sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:IOS.bg, border:`1px solid ${IOS.separator}`, display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
                            </Box>
                            {puedeEditar && h.estado==='ACTIVO' && (<>
                              <Box onClick={()=>abrirEdicion(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                              </Box>
                              {puedeEliminar && (
                                <Box onClick={()=>setModalDel(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:'#FFF0EF', display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                                </Box>
                              )}
                            </>)}
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  {/* Desktop — tabla */}
                  <Box sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto', '&::-webkit-scrollbar':{ height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                      <thead>
                        <tr>
                          <TH>#</TH><TH>Documento</TH><TH>Fecha</TH><TH>Hora</TH><TH>Servicio</TH>
                          <TH>Paciente</TH><TH>DNI</TH><TH>F. Dev.</TH><TH center>Ítems</TH><TH center>Total</TH><TH>Estado</TH><TH></TH>
                        </tr>
                      </thead>
                      <tbody>
                        {histPaginado.map((h,idx)=>(
                          <tr key={h.fdc_id} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface, transition:'background 0.1s' }}
                            onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                            onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                            <td style={{ padding:'8px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{(pagH-1)*filasH+idx+1}</td>
                            <td style={{ padding:'8px 10px', fontFamily:'monospace', fontWeight:700, color:IOS.blue, whiteSpace:'nowrap' }}>{h.documento}</td>
                            <td style={{ padding:'8px 10px', color:IOS.label, whiteSpace:'nowrap' }}>{h.fecha}</td>
                            <td style={{ padding:'8px 10px', color:IOS.label2, fontFamily:'monospace', fontSize:'0.7rem' }}>{h.hora}</td>
                            <td style={{ padding:'8px 10px', color:IOS.label }}>{h.fdc_servicio}</td>
                            <td style={{ padding:'8px 10px', maxWidth:180 }}>
                              <Tooltip title={h.fdc_paciente||''} placement="top">
                                <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180, color:IOS.label }}>{h.fdc_paciente||'-'}</span>
                              </Tooltip>
                            </td>
                            <td style={{ padding:'8px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{h.fdc_dni||'-'}</td>
                            <td style={{ padding:'8px 10px', color:IOS.label, whiteSpace:'nowrap' }}>{h.fecha_dev}</td>
                            <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700, color:IOS.label }}>{h.nro_medicamentos}</td>
                            <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700, color:IOS.label }}>{h.total_items}</td>
                            <td style={{ padding:'8px 10px' }}>
                              <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:h.estado==='ACTIVO'?'#EDFAF2':'#FFF0EF', border:`1px solid ${h.estado==='ACTIVO'?'#B7EFD0':'#FFD4D1'}` }}>
                                <Box sx={{ width:4, height:4, borderRadius:'50%', bgcolor:h.estado==='ACTIVO'?IOS.green:IOS.red }} />
                                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:h.estado==='ACTIVO'?'#1A6B3C':'#C0392B' }}>{h.estado}</Typography>
                              </Box>
                            </td>
                            <td style={{ padding:'6px 8px', textAlign:'center' }}>
                              <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.8, justifyContent:'center' }}>
                                <Tooltip title="Exportar" placement="top">
                                  <Box onClick={()=>abrirSelector('individual', h)}
                                    sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:IOS.bg, border:`1px solid ${IOS.separator}`, display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer', transition:'all 0.15s', '&:hover':{ bgcolor:'#E5E5EA' } }}>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
                                  </Box>
                                </Tooltip>
                                {puedeEditar && h.estado==='ACTIVO' && (<>
                                <Tooltip title="Modificar" placement="top">
                                  <Box onClick={()=>abrirEdicion(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer', transition:'all 0.15s', '&:hover':{ bgcolor:`${IOS.blue}22` } }}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                  </Box>
                                </Tooltip>
                                {puedeEliminar && (
                                  <Tooltip title="Eliminar" placement="top">
                                    <Box onClick={()=>setModalDel(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:'#FFF0EF', display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer', transition:'all 0.15s', '&:hover':{ bgcolor:'#FFD4D1' } }}>
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                                    </Box>
                                  </Tooltip>
                                )}
                              </>)}
                              </Box>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                  <Paginacion total={historial.length} pagina={pagH} setPagina={setPagH} rpp={filasH} />
                </Box>
              )}
            </Box>
          )}

          {/* ══ TAB 2: INDICADORES ══ */}
          {tab===2 && (
            <Box>
              {/* Sub-tabs: Nuevo / Historial */}
              <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.5, bgcolor:IOS.surface, borderRadius:'10px', p:0.4,
                width:'fit-content', maxWidth:'100%', overflowX:'auto', mb:2, boxShadow:'0 1px 3px rgba(0,0,0,0.07)',
                '&::-webkit-scrollbar':{ display:'none' } }}>
                {['Nuevo Indicador','Historial'].map((t,i)=>(
                  <Box key={i} onClick={()=>{ 
                      setISubTab(i); 
                      if(i===1) cargarHistorialInd(); 
                    }}
                    sx={{ px:2.5, py:0.8, borderRadius:'10px', cursor:'pointer',
                      bgcolor: iSubTab===i ? IOS.bg : 'transparent',
                      boxShadow: iSubTab===i ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                      transition:'all 0.2s' }}>
                    <Typography sx={{ fontSize:'0.82rem', 
                      fontWeight: iSubTab===i ? 700 : 500,
                      color: iSubTab===i ? IOS.label : IOS.label2 }}>{t}</Typography>
                  </Box>
                ))}
              </Box>
{iSubTab === 0 && (
  <>
              {/* ── Filtros periodo ── */}
              <Card mb={2}>
                <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, flexWrap:'wrap', alignItems:'flex-end' }}>
                  <Box sx={{ minWidth:{ xs:'calc(50% - 6px)', sm:130 } }}>
                    <Lbl>Mes</Lbl>
                    <Sel value={iMes} onChange={e=>setIMes(parseInt(e.target.value))}>
                      {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                    </Sel>
                  </Box>
                  <Box sx={{ minWidth:100 }}>
                    <Lbl>Año</Lbl>
                    <Sel value={iAnio} onChange={e=>setIAnio(parseInt(e.target.value))}>
                      {ANIOS.map(a=><option key={a} value={a}>{a}</option>)}
                    </Sel>
                  </Box>
                  <Box sx={{ minWidth:180 }}>
                    <Lbl>Servicio</Lbl>
                    <Sel value={iServicio} onChange={e=>{
                        setIServicio(e.target.value);
                        if(iConsultado && e.target.value !== iServConsultado){
                          resetFormIndicadores();   // limpia tabla y formulario
                        }
                      }}>
                      {SERVICIOS.filter(s=>!iServReg.includes(s))
                        .map(s=><option key={s} value={s}>{s}</option>)}
                    </Sel>
                  </Box>
                  <Box className="pharmacy-layout pharmacy-action" component="button" onClick={consultarIndicadores} disabled={iCargando || !iServicio}
                    sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:'#AF52DE',
                      cursor:iCargando?'default':'pointer', display:'flex', alignItems:'center',
                      gap:0.8, alignSelf:'flex-end', '&:hover':{ filter:'brightness(0.92)' } }}>
                    {iCargando&&<CircularProgress size={13} sx={{ color:'white' }} />}
                    <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>
                      {iCargando?'Consultando...':'Consultar'}
                    </Typography>
                  </Box>
                </Box>
              </Card>

              {iServReg.length>0 && (
                <Box className="pharmacy-layout" sx={{ mb:2, p:1.5, borderRadius:'12px', bgcolor:'#FFF8E6', border:'1px solid #FFE9A0',
                  display:'flex', alignItems:'center', gap:1, flexWrap:'wrap' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:700, color:'#8B6914' }}>
                    Ya registrados en {MESES[iMes-1]} {iAnio}:
                  </Typography>
                  {iServReg.map(s=>(
                    <Box key={s} sx={{ px:1, py:0.2, borderRadius:'20px', bgcolor:'#FDE68A' }}>
                      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#92400E' }}>{s}</Typography>
                    </Box>
                  ))}
                  {!iServicio && (
                    <Typography sx={{ fontSize:'0.78rem', fontWeight:600, color:'#C0392B', ml:'auto' }}>
                      Periodo completo — revisa el Historial
                    </Typography>
                  )}
                </Box>
              )}

              {/* ── Tabla de resultados ── */}
              {iTabla.length > 0 && (
                <Card mb={2} p={0}>
                  <Box className="pharmacy-layout" sx={{ px:2.5, py:1.8, borderBottom:`1px solid ${IOS.separator}`,
                    display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <Typography sx={{ fontWeight:700, fontSize:'0.88rem', color:IOS.label }}>
                      Atendido vs Devuelto — {MESES[iMes-1]} {iAnio}
                    </Typography>
                  </Box>
                  {/* Móvil — cards */}
                  <Box sx={{ display:{ xs:'block', md:'none' } }}>
                    {iTabla.map((row,i)=>(
                      <Box key={i} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}` }}>
                        <Typography sx={{ fontWeight:700, fontSize:'0.85rem', color:IOS.label, mb:1 }}>{row.servicio}</Typography>
                        <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1 }}>
                          <Box sx={{ bgcolor:`${IOS.blue}08`, border:`1px solid ${IOS.blue}25`, borderRadius:'10px', p:1 }}>
                            <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue, mb:0.6 }}>ATENDIDO (B)</Typography>
                            <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Prescripciones: <b style={{ color:IOS.label }}>{row.recetas}</b></Typography>
                            <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Unidades: <b style={{ color:IOS.label }}>{row.items}</b></Typography>
                            <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Costo: <b style={{ color:IOS.label }}>S/ {parseFloat(row.total||0).toFixed(2)}</b></Typography>
                          </Box>
                          <Box sx={{ bgcolor:'rgba(52,199,89,.1)', border:'1px solid rgba(52,199,89,.3)', borderRadius:'10px', p:1 }}>
                            <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#1A7F35', mb:0.6 }}>DEVUELTO (A)</Typography>
                            <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Unidades: <b style={{ color:'#1A7F35' }}>{row.cantidadDev}</b></Typography>
                            <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>Costo: <b style={{ color:'#1A7F35' }}>S/ {parseFloat(row.totDev||0).toFixed(2)}</b></Typography>
                          </Box>
                        </Box>
                        <Box sx={{ mt:1, textAlign:'center' }}>
                          <Box sx={{ display:'inline-flex', px:1.2, py:0.4, borderRadius:'20px',
                            bgcolor: parseFloat(row.items)>0&&parseFloat(row.cantidadDev/row.items*100)>20 ? 'rgba(255,59,48,.12)':'rgba(52,199,89,.12)' }}>
                            <Typography sx={{ fontSize:'0.82rem', fontWeight:800,
                              color: parseFloat(row.items)>0&&parseFloat(row.cantidadDev/row.items*100)>20 ? IOS.red:'#1A7F35' }}>
                              (A×100)/B = {pct(row.cantidadDev, row.items)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  {/* Desktop — tabla */}
                  <Box sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.78rem' }}>
                      <thead>
                        <tr>
                          <TH>Servicio</TH>
                          <TH></TH>
                          <TH center>Nº Prescripciones</TH>
                          <TH center>Nº Unidades</TH>
                          <TH center>Costo Total</TH>
                          <TH center>(A×100)/B</TH>
                        </tr>
                      </thead>
                      <tbody>
                        {iTabla.map((row, i) => (
                          <React.Fragment key={i}>
                            {/* Fila ATENDIDO (B) */}
                            <tr style={{ borderBottom:`1px solid ${IOS.separator}`,
                              backgroundColor: i%2===0 ? IOS.surface : IOS.bg }}>
                              {/* Servicio abarca 2 filas */}
                              <td rowSpan={2} style={{ padding:'8px 12px', fontWeight:700, color: IOS.label,
                                borderRight:`1px solid ${IOS.separator}`, fontSize:'0.8rem',
                                verticalAlign:'middle' }}>
                                {row.servicio}
                              </td>
                              <td style={{ padding:'8px 10px' }}>
                                <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5,
                                  px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor:`${IOS.blue}12`, border:`1px solid ${IOS.blue}25` }}>
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>
                                    ATENDIDO (B)
                                  </Typography>
                                </Box>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:IOS.label }}>{row.recetas}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:IOS.label }}>{row.items}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:IOS.label }}>S/ {parseFloat(row.total||0).toFixed(2)}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center', color:IOS.label3 }}>—</td>
                            </tr>
                            {/* Fila DEVUELTO (A) — SIN la celda de servicio porque tiene rowSpan=2 */}
                            <tr style={{ borderBottom:`2px solid ${IOS.separator}`,
                              backgroundColor: i%2===0 ? '#EDFAF2' : '#E8F8F0' }}>
                              <td style={{ padding:'8px 10px' }}>
                                <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5,
                                  px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor:'rgba(52,199,89,.15)', border:'1px solid rgba(52,199,89,.3)' }}>
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#1A7F35' }}>
                                    DEVUELTO (A)
                                  </Typography>
                                </Box>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:'#1A7F35' }}>{row.cantidadDev}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:'#1A7F35' }}>{row.cantidadDev}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:'#1A7F35' }}>S/ {parseFloat(row.totDev||0).toFixed(2)}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor: parseFloat(row.items)>0&&parseFloat(row.cantidadDev/row.items*100)>20
                                    ?'rgba(255,59,48,.12)':'rgba(52,199,89,.12)' }}>
                                  <Typography sx={{ fontSize:'0.78rem', fontWeight:800,
                                    color: parseFloat(row.items)>0&&parseFloat(row.cantidadDev/row.items*100)>20
                                      ?IOS.red:'#1A7F35' }}>
                                    {pct(row.cantidadDev, row.items)}
                                  </Typography>
                                </Box>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                </Card>
              )}

              {/* ── Formulario adicional ── */}
              {iConsultado && (
                <Card mb={2}>
                  <Typography sx={{ fontSize:'0.72rem', fontWeight:700, color:IOS.label,
                    mb:1.8, pb:1, borderBottom:`1px solid ${IOS.separator}` }}>
                    Datos complementarios del indicador
                  </Typography>
                  <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', md:'1fr 1fr' }, gap:2.5 }}>

                    {/* Columna izquierda */}
                    <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
                      <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr' }, gap:1.5 }}>
                        <Box>
                          <Lbl>Disp. DMDU</Lbl>
                          <Sel value={iDispDosis} onChange={e=>{
                            setIDispDosis(e.target.value);
                            if(e.target.value==='NO') setICamas('0');
                          }}>
                            {SI_NO.map(v=><option key={v} value={v}>{v}</option>)}
                          </Sel>
                        </Box>
                        <Box>
                          <Lbl>Nº Total Camas</Lbl>
                          <Inp type="number" value={iTotalCamas} onChange={e=>setITotalCamas(e.target.value)} placeholder="0"/>
                        </Box>
                        <Box>
                          <Lbl>Servicio DMDU</Lbl>
                          <Inp value={iServConsultado} readOnly blue />
                        </Box>
                        <Box>
                          <Lbl>Nº Camas DMDU</Lbl>
                          <Inp type="number" value={iDispDosis==='NO'?'0':iCamas}
                            onChange={e=>setICamas(e.target.value)}
                            readOnly={iDispDosis==='NO'}
                            placeholder="0"/>
                        </Box>
                      </Box>

                      {/* Servicio de dispensación */}
                      <Box sx={{ bgcolor:IOS.bg, borderRadius:'12px', p:1.5 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                          textTransform:'uppercase', letterSpacing:'.06em', mb:1 }}>
                          Servicio de dispensación
                        </Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', gap:2, flexWrap:'wrap' }}>
                          {[['Ambulatorio',iChkA,setIChkA],
                            ['Internamiento',iChkI,setIChkI],
                            ['Hospitalizado',iChkH,setIChkH]].map(([lbl,val,set])=>(
                            <Box className="pharmacy-layout" key={lbl} onClick={()=>set(!val)}
                              sx={{ display:'flex', alignItems:'center', gap:0.8, cursor:'pointer' }}>
                              <Box className="pharmacy-layout" sx={{ width:16, height:16, borderRadius:'4px',
                                border:`2px solid ${val?'#AF52DE':IOS.separator}`,
                                bgcolor:val?'#AF52DE':'transparent',
                                display:'flex', alignItems:'center', justifyContent:'center',
                                transition:'all 0.15s' }}>
                                {val&&<svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                                  <path d="M2 5l2.5 2.5L8 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>}
                              </Box>
                              <Typography sx={{ fontSize:'0.78rem', color:IOS.label }}>{lbl}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>

                      {/* Dispensación especializada */}
                      <Box sx={{ bgcolor:IOS.bg, borderRadius:'12px', p:1.5 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                          textTransform:'uppercase', letterSpacing:'.06em', mb:1 }}>
                          S. dispensación especializada
                        </Typography>
                        <Box className="pharmacy-layout" sx={{ display:'flex', gap:2, flexWrap:'wrap' }}>
                          {[['Emergencia',iChkE,setIChkE],
                            ['SOP',iChkS,setIChkS],
                            ['UCI',iChkU,setIChkU]].map(([lbl,val,set])=>(
                            <Box className="pharmacy-layout" key={lbl} onClick={()=>set(!val)}
                              sx={{ display:'flex', alignItems:'center', gap:0.8, cursor:'pointer' }}>
                              <Box className="pharmacy-layout" sx={{ width:16, height:16, borderRadius:'4px',
                                border:`2px solid ${val?'#AF52DE':IOS.separator}`,
                                bgcolor:val?'#AF52DE':'transparent',
                                display:'flex', alignItems:'center', justifyContent:'center',
                                transition:'all 0.15s' }}>
                                {val&&<svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                                  <path d="M2 5l2.5 2.5L8 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>}
                              </Box>
                              <Typography sx={{ fontSize:'0.78rem', color:IOS.label }}>{lbl}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>

                      {/* Seguimiento */}
                      <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr' }, gap:1.5 }}>
                        <Box>
                          <Lbl>Seg. Inter. Hosp.</Lbl>
                          <Sel value={iSegIH} onChange={e=>setISegIH(e.target.value)}>
                            {SI_NO.map(v=><option key={v} value={v}>{v}</option>)}
                          </Sel>
                        </Box>
                        <Box>
                          <Lbl>Nº Pacientes</Lbl>
                          <Inp type="number" value={iSegIH==='NO'?'0':iSegIHPac}
                            onChange={e=>setISegIHPac(e.target.value)}
                            readOnly={iSegIH==='NO'}
                            placeholder="0"/>
                        </Box>
                        <Box>
                          <Lbl>Seg. Ambulatorio</Lbl>
                          <Sel value={iSegAmb} onChange={e=>setISegAmb(e.target.value)}>
                            {SI_NO.map(v=><option key={v} value={v}>{v}</option>)}
                          </Sel>
                        </Box>
                        <Box>
                          <Lbl>Nº Pacientes</Lbl>
                          <Inp type="number" value={iSegAmb==='NO'?'0':iSegAmbPac}
                            onChange={e=>setISegAmbPac(e.target.value)}
                            readOnly={iSegAmb==='NO'}
                            placeholder="0"/>
                        </Box>
                      </Box>
                    </Box>

                    {/* Columna derecha — Cantidad Q.F. */}
                    <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
                      <Box sx={{ bgcolor:IOS.bg, borderRadius:'12px', p:1.5 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                          textTransform:'uppercase', letterSpacing:'.06em', mb:1.2 }}>
                          Cantidad de Q.F. por servicio
                        </Typography>
                        <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr' }, gap:1.2 }}>
                          {[['SDMDU',iQfSdmdu,setIQfSdmdu],
                            ['SFT',iQfSft,setIQfSft],
                            ['Dispensación',iQfDisp,setIQfDisp],
                            ['Disp. Especializada',iQfDispEsp,setIQfDispEsp]].map(([lbl,val,set])=>(
                            <Box key={lbl}>
                              <Lbl>{lbl}</Lbl>
                              <Inp type="number" value={val} onChange={e=>set(e.target.value)} placeholder="0"/>
                            </Box>
                          ))}
                        </Box>
                      </Box>

                      <Box sx={{ bgcolor:IOS.bg, borderRadius:'12px', p:1.5 }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                          textTransform:'uppercase', letterSpacing:'.06em', mb:1.2 }}>
                          Seguimiento Farmacoterapéutico — SFT
                        </Typography>
                        <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr' }, gap:1.2 }}>
                          {[['Pacientes SDMDU', iSftB1, setISftB1],
                            ['Pacientes con SFT', iSftA1, setISftA1],
                            ['Pacientes PRM detectados', iSftA2, setISftA2],
                            ['Total pacientes PRM', iSftB3, setISftB3],
                            ['Intervenciones farm. PRM', iSftA3, setISftA3],
                            ['Sospechas RAM', iSftA4, setISftA4],
                            ['Errores dispensación', iErroresDisp, setIErroresDisp]].map(([lbl,val,set])=>(
                            <Box key={lbl}>
                              <Lbl>{lbl}</Lbl>
                              <Inp type="number" value={val} onChange={e=>set(e.target.value)} placeholder="0"/>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  {/* Mensajes y botón guardar */}
                  {(iMsgOk||iMsgErr) && (
                    <Box sx={{ mt:2, p:1.5, borderRadius:'12px',
                      bgcolor:iMsgOk?'#EDFAF2':'#FFF0EF',
                      border:`1px solid ${iMsgOk?'#B7EFD0':'#FFD4D1'}` }}>
                      <Typography sx={{ fontSize:'0.82rem', fontWeight:600,
                        color:iMsgOk?'#1A6B3C':'#C0392B' }}>{iMsgOk||iMsgErr}</Typography>
                    </Box>
                  )}
         <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'flex-end', mt:2 }}>
  <Box className="pharmacy-layout pharmacy-action" component="button" onClick={guardarIndicadores} 
    disabled={!puedeEditar || iGuardando || !iConsultado || !iTabla.length}
    sx={{ height:36, px:3, borderRadius:'10px', border:'none',
      bgcolor: iGuardando || !iConsultado || !iTabla.length ? '#E5E5EA' : '#AF52DE',
      cursor: iGuardando || !iConsultado || !iTabla.length ? 'default' : 'pointer',
      display:'flex', alignItems:'center', gap:0.8,
      '&:hover':{ filter:'brightness(0.92)' } }}>
    {iGuardando&&<CircularProgress size={13} sx={{ color:'white' }} />}
    <Typography sx={{ fontSize:'0.82rem', fontWeight:700,
      color: iGuardando || !iConsultado || !iTabla.length ? '#8E8E93' : 'white' }}>
      {iGuardando?'Guardando...':'Guardar Indicadores'}
    </Typography>
  </Box>
</Box>
                </Card>
                
                )}
              </>
            )}

              {/* ── Historial de indicadores ── */}
               {iSubTab === 1 && (
              <Card mb={2} p={0}>
                <Box className="pharmacy-layout pharmacy-toolbar" sx={{ px:2.5, py:2, borderBottom:`1px solid ${IOS.separator}`,
                  display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:1.5 }}>
                  <Typography sx={{ fontWeight:700, fontSize:'0.88rem', color:IOS.label, width:{ xs:'100%', sm:'auto' } }}>
                    Historial de Indicadores
                  </Typography>
                  <Box className="pharmacy-layout pharmacy-toolbar" sx={{ display:'flex', gap:1.5, alignItems:'flex-end', flexWrap:'wrap', width:{ xs:'100%', sm:'auto' } }}>
                    <Box>
                      <Lbl>Mes</Lbl>
                      <Sel value={ihMes} onChange={e=>setIhMes(e.target.value)}>
                        <option value="">Todos</option>
                        {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                      </Sel>
                    </Box>
                    <Box>
                      <Lbl>Año</Lbl>
                      <Sel value={ihAnio} onChange={e=>setIhAnio(e.target.value)}>
                        <option value="">Todos</option>
                        {ANIOS.map(a=><option key={a} value={a}>{a}</option>)}
                      </Sel>
                    </Box>
                    <Box className="pharmacy-layout pharmacy-action" component="button" onClick={cargarHistorialInd} disabled={ihCargando}
                      sx={{ height:34, px:2, borderRadius:'10px', border:'none', bgcolor:IOS.blue,
                        cursor:'pointer', display:'flex', alignItems:'center', gap:0.8,
                        alignSelf:'flex-end', '&:hover':{ filter:'brightness(0.92)' } }}>
                      {ihCargando&&<CircularProgress size={13} sx={{ color:'white' }} />}
                      <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>
                        {ihCargando?'...':'Filtrar'}
                      </Typography>
                    </Box>
                    <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalConsol(true)}
                      sx={{ height:34, px:2, borderRadius:'10px', border:'none', bgcolor:'#AF52DE',
                        cursor:'pointer', display:'flex', alignItems:'center', gap:0.8,
                        alignSelf:'flex-end', '&:hover':{ filter:'brightness(0.92)' } }}>
                      <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>
                        PDF Consolidado
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {ihCargando
                  ?<Box sx={{ py:6, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>
                  :ihLista.length===0
                    ?<Box sx={{ py:6, textAlign:'center' }}>
                      <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Sin registros</Typography>
                    </Box>
                    :<>
                    {/* Móvil — cards */}
                    <Box sx={{ display:{ xs:'block', md:'none' } }}>
                      {ihLista.map((h,i)=>(
                        <Box key={h.fdcId} sx={{ p:2, borderBottom:`1px solid ${IOS.separator}`,
                          bgcolor:h.fdcId===ihRegistroMarcado?`${IOS.orange}15`:'transparent',
                          borderLeft:h.fdcId===ihRegistroMarcado?`3px solid ${IOS.orange}`:'3px solid transparent' }}>
                          <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', mb:0.5 }}>
                            <Typography sx={{ fontWeight:700, fontSize:'0.85rem', color:'#AF52DE' }}>{MESES[h.mes-1]} {h.anio}</Typography>
                            <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px',
                              bgcolor:h.dispDosis==='SI'?'#EDFAF2':'#F2F2F7', border:`1px solid ${h.dispDosis==='SI'?'#B7EFD0':IOS.separator}` }}>
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:h.dispDosis==='SI'?'#1A6B3C':IOS.label2 }}>{h.dispDosis}</Typography>
                            </Box>
                          </Box>
                          <Typography sx={{ fontSize:'0.78rem', color:IOS.label, mb:0.8 }}>{h.servicio}</Typography>
                          <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mb:1 }}>Camas: {h.camas}/{h.totalCamas} · Servicios: {h.nroServicios} · {h.usuario} · {h.fechaCreacion?.slice(0,10)}</Typography>
                          <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.8 }}>
                            <Box onClick={()=>verIndicador(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:'rgba(175,82,222,.12)', display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#AF52DE" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                            </Box>
                            <Box onClick={()=>imprimirIndicador(h)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:`${IOS.green}12`, display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="2" strokeLinecap="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
                            </Box>
                            <Box role="button" aria-label="Eliminar indicador" aria-disabled={!puedeEliminar} onClick={()=>{if(puedeEliminar)setIhDelItem(h);}} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:'#FFF0EF', display:'inline-flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                    {/* Desktop — tabla */}
                    <Box sx={{ display:{ xs:'none', md:'block' }, overflowX:'auto' }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                        <thead>
                          <tr>
                            <TH>#</TH><TH>Periodo</TH><TH>Servicio</TH>
                            <TH center>Disp. DMDU</TH><TH center>Camas</TH>
                            <TH center>Servicios</TH><TH>Guardado</TH><TH></TH>
                          </tr>
                        </thead>
                        <tbody>
                          {ihLista.map((h,i)=>(
                              <tr key={h.fdcId} 
    style={{ 
      borderBottom:`1px solid ${IOS.separator}`,
      backgroundColor: h.fdcId === ihRegistroMarcado 
        ? `${IOS.orange}15`   // ← fondo naranja suave si está marcado
        : IOS.surface,
      transition:'background 0.1s',
      borderLeft: h.fdcId === ihRegistroMarcado 
        ? `3px solid ${IOS.orange}` 
        : '3px solid transparent'
    }}
    onMouseEnter={e=>e.currentTarget.style.backgroundColor=
      h.fdcId===ihRegistroMarcado?`${IOS.orange}20`:IOS.bg}
    onMouseLeave={e=>e.currentTarget.style.backgroundColor=
      h.fdcId===ihRegistroMarcado?`${IOS.orange}15`:IOS.surface}>
                              <td style={{ padding:'8px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{i+1}</td>
                              <td style={{ padding:'8px 10px', fontWeight:700, color:'#AF52DE' }}>
                                {MESES[h.mes-1]} {h.anio}
                              </td>
                              <td style={{ padding:'8px 10px', color:IOS.label }}>{h.servicio}</td>
                              <td style={{ padding:'8px 10px', textAlign:'center' }}>
                                <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px',
                                  bgcolor:h.dispDosis==='SI'?'#EDFAF2':'#F2F2F7',
                                  border:`1px solid ${h.dispDosis==='SI'?'#B7EFD0':IOS.separator}` }}>
                                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700,
                                    color:h.dispDosis==='SI'?'#1A6B3C':IOS.label2 }}>{h.dispDosis}</Typography>
                                </Box>
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center', color:IOS.label }}>
                                {h.camas} / {h.totalCamas}
                              </td>
                              <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700,
                                color:IOS.blue }}>{h.nroServicios}</td>
                              <td style={{ padding:'8px 10px', fontSize:'0.7rem', color:IOS.label2 }}>
                                {h.usuario} · {h.fechaCreacion?.slice(0,10)}
                              </td>
                              <td style={{ padding:'6px 8px', textAlign:'center' }}>
                                <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.8, justifyContent:'center' }}>
                                  <Tooltip title="Ver detalle" placement="top">
                                    <Box onClick={()=>verIndicador(h)}
                                      sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%',
                                        bgcolor:'rgba(175,82,222,.12)', display:'inline-flex',
                                        alignItems:'center', justifyContent:'center',
                                        cursor:'pointer', '&:hover':{ bgcolor:'rgba(175,82,222,.22)' } }}>
                                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                        stroke="#AF52DE" strokeWidth="2" strokeLinecap="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                        <circle cx="12" cy="12" r="3"/>
                                      </svg>
                                    </Box>
                                  </Tooltip>
                                  <Tooltip title="Eliminar" placement="top">
                                    <Box role="button" aria-label="Eliminar indicador" aria-disabled={!puedeEliminar} onClick={()=>{if(puedeEliminar)setIhDelItem(h);}}
                                      sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', bgcolor:'#FFF0EF',
                                        display:'inline-flex', alignItems:'center', justifyContent:'center',
                                        cursor:'pointer', '&:hover':{ bgcolor:'#FFD4D1' } }}>
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                        stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                                        <polyline points="3 6 5 6 21 6"/>
                                        <path d="M19 6l-1 14H6L5 6"/>
                                        <path d="M10 11v6M14 11v6"/>
                                        <path d="M9 6V4h6v2"/>
                                      </svg>
                                    </Box>
                                  </Tooltip>
                                  <Tooltip title="Imprimir" placement="top">
                                    <Box onClick={() => imprimirIndicador(h)}
                                      sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%',
                                        bgcolor:`${IOS.green}12`, display:'inline-flex',
                                        alignItems:'center', justifyContent:'center',
                                        cursor:'pointer', '&:hover':{ bgcolor:`${IOS.green}22` } }}>
                                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                        stroke={IOS.green} strokeWidth="2" strokeLinecap="round">
                                        <polyline points="6 9 6 2 18 2 18 9"/>
                                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                                        <rect x="6" y="14" width="12" height="8" rx="1"/>
                                      </svg>
                                    </Box>
                                  </Tooltip>
                                </Box>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Box>
                    </>
                 }
              </Card>
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Modal edición ─────────────────────────────────────────────────────── */}
      {editItem && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.45)', zIndex:9999, display:'flex', alignItems:'flex-start', justifyContent:'center', p:2, overflowY:'auto', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'20px', width:'100%', maxWidth:860, my:2, boxShadow:'0 24px 60px rgba(0,0,0,0.2)', overflow:'hidden' }}>
            <Box className="pharmacy-layout" sx={{ px:2.5, pt:2.5, pb:2, borderBottom:`1px solid ${IOS.separator}`, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <Box>
                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase', mb:0.3 }}>Editar</Typography>
                <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label }}>{editItem.documento}</Typography>
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setEditItem(null)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', '&:hover':{ bgcolor:'#D1D1D6' } }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </Box>
            </Box>
            {cargandoEdit
              ?<Box sx={{ py:8, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>
              :editCab&&(
                <Box sx={{ p:2.5 }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase', mb:1.2, pb:0.8, borderBottom:`1px solid ${IOS.separator}` }}>Datos del documento</Typography>
                  <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(120px, 1fr))', gap:1.2, mb:2.5 }}>
                    <Box><Lbl>Fecha</Lbl><DatePickerIOS value={editCab.fdcFecha} onChange={v=>setEditCab(p=>({...p,fdcFecha:v,fdcFechaDev:v}))} /></Box>
                    <Box><Lbl>Hora</Lbl><Inp type="time" value={editCab.fdcHora} onChange={e=>setEditCab(p=>({...p,fdcHora:e.target.value,fdcHoraDev:e.target.value}))} /></Box>
                    <Box sx={{ gridColumn:'span 2' }}><Lbl>Servicio</Lbl><Sel value={editCab.fdcServicio} onChange={e=>setEditCab(p=>({...p,fdcServicio:e.target.value}))}>{SERVICIOS.map(s=><option key={s} value={s}>{s}</option>)}</Sel></Box>
                    <Box><Lbl>F. Pago</Lbl><Inp value={editCab.fdcFp} readOnly /></Box>
                    <Box><Lbl>Serie</Lbl><Inp value={editCab.fdcSerie} readOnly mono /></Box>
                    <Box><Lbl>Correlativo</Lbl><Inp value={editCab.fdcCorrelativo} readOnly mono /></Box>
                    <Box><Lbl>DNI</Lbl><Inp value={editCab.fdcDni} readOnly mono /></Box>
                    <Box sx={{ gridColumn:'span 3' }}>
                      <Lbl>Paciente {editCab?.fdcFp?.toUpperCase()==='GUIA'&&<span style={{ color:IOS.blue, fontSize: '0.72rem', marginLeft:4 }}>(editable)</span>}</Lbl>
                      <Inp value={editCab.fdcPaciente} readOnly={editCab?.fdcFp?.toUpperCase()!=='GUIA'} onChange={e=>setEditCab(p=>({...p,fdcPaciente:e.target.value}))} />
                    </Box>
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1.2, pb:0.8, borderBottom:`1px solid ${IOS.separator}` }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>Medicamentos devueltos</Typography>
                    {editCab?.fdcFp?.toUpperCase()!=='GUIA'&&(
                      <Box className="pharmacy-layout pharmacy-action" component="button" onClick={abrirPendientes} sx={{ height:28, px:1.5, borderRadius:'8px', border:'none', bgcolor:IOS.green, cursor:'pointer', display:'flex', alignItems:'center', gap:0.6, '&:hover':{ filter:'brightness(0.9)' } }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
                        <Typography sx={{ fontSize:'0.72rem', fontWeight:700, color:'white' }}>Agregar pendientes</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box sx={{ overflowX:'auto', mb:2 }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                      <thead>
                        <tr>
                          <TH>Producto</TH><TH>Reg. San.</TH><TH>Lote</TH><TH>F. Venc</TH><TH center>Dispensado</TH><TH center>Devuelta</TH>
                        </tr>
                      </thead>
                      <tbody>
                        {editDet.map((d,i)=>{ const esGuia=editCab?.fdcFp?.toUpperCase()==='GUIA'; return (
                          <tr key={d.fddId||i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:i%2===0?IOS.surface:IOS.bg }}>
                            <td style={{ padding:'6px 10px', color:IOS.label, fontSize:'0.78rem' }}>{d.producto}</td>
                            <td style={{ padding:'5px 6px', minWidth:100 }}>{esGuia?<input value={d.fddRegSan} onChange={e=>setEditDet(prev=>prev.map((x,j)=>j===i?{...x,fddRegSan:e.target.value}:x))} style={{ width:'100%', height:30, padding:'0 6px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', fontFamily:'monospace', backgroundColor:IOS.surface, color:IOS.label }} />:<span style={{ fontSize:'0.76rem', color:IOS.label2, fontFamily:'monospace' }}>{d.fddRegSan||'-'}</span>}</td>
                            <td style={{ padding:'5px 6px', minWidth:100 }}>{esGuia?<input value={d.fddLote} onChange={e=>setEditDet(prev=>prev.map((x,j)=>j===i?{...x,fddLote:e.target.value}:x))} style={{ width:'100%', height:30, padding:'0 6px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', fontFamily:'monospace', backgroundColor:IOS.surface, color:IOS.label }} />:<span style={{ fontSize:'0.76rem', color:IOS.label2, fontFamily:'monospace' }}>{d.fddLote||'-'}</span>}</td>
                            <td style={{ padding:'5px 6px', minWidth:120 }}>{esGuia?<input type="date" value={d.fechaVencInput} onChange={e=>setEditDet(prev=>prev.map((x,j)=>j===i?{...x,fechaVencInput:e.target.value}:x))} style={{ width:'100%', height:30, padding:'0 6px', border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.76rem', outline:'none', boxSizing:'border-box', backgroundColor:IOS.surface, color:IOS.label }} />:<span style={{ fontSize:'0.76rem', color:IOS.label2 }}>{d.fechaVenc||'-'}</span>}</td>
                            <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700, color:IOS.label }}>{d.fddCantidad}</td>
                            <td style={{ padding:'5px 6px', textAlign:'center', minWidth:80 }}>
                              <input type="number" min="0" value={d.fddDevuelto}
                                onChange={e=>{const v=parseFloat(e.target.value);const max=esGuia?Infinity:(parseFloat(d.fddCantidad)||0);setEditDet(prev=>prev.map((x,j)=>j===i?{...x,fddDevuelto:(!e.target.value||esGuia||v<=max)?e.target.value:String(max)}:x));}}
                                style={{ width:72, height:30, padding:'0 6px', border:`1px solid ${d.fddDevuelto?`${IOS.blue}50`:IOS.separator}`, borderRadius:8, fontSize:'0.82rem', textAlign:'center', outline:'none', backgroundColor:d.fddDevuelto?`${IOS.blue}08`:IOS.surface, color:IOS.label }} />
                             </td>
                           </tr>
                        );})}
                      </tbody>
                    </table>
                  </Box>
                  {(msgOkEdit||msgErrEdit)&&<Box sx={{ p:1.5, borderRadius:'10px', mb:2, bgcolor:msgOkEdit?'#EDFAF2':'#FFF0EF', border:`1px solid ${msgOkEdit?'#B7EFD0':'#FFD4D1'}` }}><Typography sx={{ fontSize:'0.8rem', fontWeight:600, color:msgOkEdit?'#1A6B3C':'#C0392B' }}>{msgOkEdit||msgErrEdit}</Typography></Box>}
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.5, justifyContent:'flex-end' }}>
                    <Box className="pharmacy-action" component="button" onClick={()=>setEditItem(null)} sx={{ height:34, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`, bgcolor:IOS.surface, cursor:'pointer', fontSize:'0.8rem', fontWeight:600, color:IOS.label }}>Cancelar</Box>
                    <Box className="pharmacy-layout pharmacy-action" component="button" onClick={guardarEdicion} disabled={!puedeEditar||guardandoEdit} sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:guardandoEdit?'#E5E5EA':IOS.blue, cursor:guardandoEdit?'default':'pointer', display:'flex', alignItems:'center', gap:0.8, transition:'all 0.15s' }}>
                      {guardandoEdit&&<CircularProgress size={12} sx={{ color:'white' }} />}
                      <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:guardandoEdit?'#8E8E93':'white' }}>{guardandoEdit?'Guardando...':'Guardar cambios'}</Typography>
                    </Box>
                  </Box>
                </Box>
              )}
          </Box>
        </Box>
      )}

      {/* Modal Buscador Producto */}
      <ModalBuscadorProducto open={modalProd} onClose={()=>setModalProd(false)} ueId={ueId}
        onSelect={prod=>{
          const existente = itemsMasivo.find(x=> x.id!==filaModal && x.medcod===prod.codigo && (x.lote||'')===(prod.lote||''));
          if(existente){
            setModalProd(false);
            setItemsMasivo(prev=>prev.map(x=>x.id===filaModal&&!x.medcod?null:x).filter(Boolean));
            setTimeout(()=>{ const el = document.getElementById(`cant-${existente.id}`); if(el){ el.style.border=`2px solid ${IOS.orange}`; el.focus(); el.select(); setTimeout(()=>{ el.style.border=`1px solid ${IOS.separator}`; },2000); } },50);
            setMsgErr(`"${prod.producto}" (lote: ${prod.lote||'sin lote'}) ya está en la lista`);
            setTimeout(()=>setMsgErr(''),3500); return;
          }
          setItemsMasivo(prev=>prev.map(x=>x.id===filaModal?{...x,medcod:prod.codigo,producto:prod.producto,regSan:prod.regSan||x.regSan,lote:prod.lote||x.lote,fechaVenc:prod.fechaVenc||x.fechaVenc}:x));
          setTimeout(()=>{ const el = document.getElementById(`cant-${filaModal}`); if(el){ el.focus(); el.select(); } }, 80);
        }}/>

      {/* Modal Pendientes */}
      {modalPendientes && editCab && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.5)', zIndex:10000, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel pharmacy-layout" sx={{ bgcolor:IOS.surface, borderRadius:{ xs:'16px', sm:'20px' }, width:'100%', maxWidth:640, mx:{ xs:1, sm:2 }, boxShadow:'0 24px 60px rgba(0,0,0,0.22)', overflow:'hidden', maxHeight:'85vh', display:'flex', flexDirection:'column' }}>
            <Box className="pharmacy-layout" sx={{ px:2.5, pt:2.5, pb:2, borderBottom:`1px solid ${IOS.separator}`, display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
              <Box>
                <Typography sx={{ fontWeight:700, fontSize:'0.92rem', color:IOS.label }}>Ítems pendientes de devolver</Typography>
                <Typography sx={{ fontSize:'0.7rem', color:IOS.label2 }}>{editCab.fdcPaciente} · {editCab.fdcSerie}-{editCab.fdcCorrelativo}</Typography>
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalPendientes(false)} sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </Box>
            </Box>
            <Box sx={{ flex:1, overflowY:'auto', '&::-webkit-scrollbar':{ width:3 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
              {cargPend
                ?<Box sx={{ py:8, textAlign:'center' }}><CircularProgress sx={{ color:IOS.green }} /></Box>
                :pendientes.length===0
                  ?<Box sx={{ py:6, textAlign:'center' }}><Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>No hay ítems pendientes de devolver para esta receta</Typography></Box>
                  :<table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                    <thead>
                      <tr><TH>Producto</TH><TH>Lote</TH><TH>F.Venc</TH><TH center>Pendiente</TH><TH center>Devolver</TH></tr>
                    </thead>
                    <tbody>{pendientes.map((p,i)=>(
                      <tr key={i} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:cantPend[i]?'#EDFAF2':i%2===0?IOS.surface:IOS.bg }}>
                        <td style={{ padding:'8px 10px' }}><Typography sx={{ fontSize:'0.76rem', fontWeight:600, color:IOS.label }}>{p.producto}</Typography><Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontFamily:'monospace' }}>{p.medregsan}</Typography></td>
                        <td style={{ padding:'8px 10px', fontFamily:'monospace', fontSize:'0.7rem', color:IOS.label2 }}>{p.medlote||'-'}</td>
                        <td style={{ padding:'8px 10px', fontFamily:'monospace', fontSize:'0.7rem', color:IOS.label2 }}>{p.medfecvto||'-'}</td>
                        <td style={{ padding:'8px 10px', textAlign:'center', fontWeight:700, color:IOS.orange }}>{p.cantidadPendiente}</td>
                        <td style={{ padding:'5px 8px', textAlign:'center' }}>
                          <input type="number" min="0" max={p.cantidadPendiente} placeholder="0" value={cantPend[i]||''}
                            onChange={e=>{ const v=parseFloat(e.target.value); const max=parseFloat(p.cantidadPendiente)||0; setCantPend(prev=>({...prev,[i]:(!e.target.value||v<=max)?e.target.value:String(max)})); }}
                            style={{ width:80, height:32, padding:'0 8px', border:`2px solid ${cantPend[i]?IOS.green:IOS.separator}`, borderRadius:8, fontSize:'0.88rem', textAlign:'center', outline:'none', backgroundColor:cantPend[i]?`${IOS.green}08`:IOS.surface, color:IOS.label, fontWeight:cantPend[i]?700:400 }} />
                        </td>
                      </tr>
                    ))}</tbody>
                  </table>
              }
            </Box>
            {!cargPend&&pendientes.length>0&&(
              <Box className="pharmacy-layout" sx={{ px:2.5, py:2, borderTop:`1px solid ${IOS.separator}`, display:'flex', justifyContent:'flex-end', gap:1.5, flexShrink:0 }}>
                <Box className="pharmacy-action" component="button" onClick={()=>setModalPendientes(false)} sx={{ height:34, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`, bgcolor:IOS.surface, cursor:'pointer', fontSize:'0.8rem', fontWeight:600, color:IOS.label2 }}>Cancelar</Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={agregarPendientes} disabled={!Object.values(cantPend).some(v=>parseFloat(v)>0)}
                  sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:Object.values(cantPend).some(v=>parseFloat(v)>0)?IOS.green:'#E5E5EA', cursor:Object.values(cantPend).some(v=>parseFloat(v)>0)?'pointer':'default', display:'flex', alignItems:'center', gap:0.8 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
                  <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:'white' }}>Agregar a la devolución</Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}

      {/* Modal Eliminar */}
      {modalDel && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.45)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'20px', p:0, width:360, mx:2, boxShadow:'0 24px 60px rgba(0,0,0,0.2)', overflow:'hidden' }}>
            <Box sx={{ p:2.5 }}>
              <Box className="pharmacy-layout" sx={{ width:48, height:48, borderRadius:'50%', bgcolor:'#FFF0EF', display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2" strokeLinecap="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              </Box>
              <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label, textAlign:'center', mb:0.5 }}>Eliminar devolución</Typography>
              <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, textAlign:'center', mb:2.5 }}>
                ¿Seguro que deseas eliminar <strong style={{ color:IOS.label }}>{modalDel.documento}</strong>? No se puede deshacer.
              </Typography>
              <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.5, justifyContent:'center' }}>
                <Box className="pharmacy-action" component="button" onClick={()=>setModalDel(null)} sx={{ height:34, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`, bgcolor:IOS.surface, cursor:'pointer', fontSize:'0.8rem', fontWeight:600, color:IOS.label }}>Cancelar</Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={eliminar} disabled={eliminando} sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', bgcolor:eliminando?'#E5E5EA':IOS.red, cursor:eliminando?'default':'pointer', display:'flex', alignItems:'center', gap:0.8 }}>
                  {eliminando&&<CircularProgress size={12} sx={{ color:'white' }} />}
                  <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:eliminando?'#8E8E93':'white' }}>{eliminando?'Eliminando...':'Sí, eliminar'}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* ── Modal selector PDF / Excel ────────────────────────────────────────── */}
      <ModalExportSelector
        open={selModal}
        onClose={() => { if(!selExportando) setSelModal(false); }}
        cargando={selExportando || pdfCargando}
        titulo="Exportar reporte"
        subtitulo={selTipo === 'individual'
          ? selFilaData ? `${selFilaData.documento}  ·  ${selFilaData.fdc_paciente||'-'}` : ''
          : `${hFechaIni}  —  ${hFechaFin}${hServicio ? '  ·  '+hServicio : ''}`
        }
        onPdf={() => selTipo === 'individual' ? verPdfIndividual(selFilaData) : verPdfConsolidado()}
        onExcel={() => selTipo === 'individual' ? descargarExcelIndividual(selFilaData) : descargarExcelConsolidado()}
      />

      {/* ── Modal PDF Visor ───────────────────────────────────────────────────── */}
      <ModalPdfVisor
        open={pdfModal}
        onClose={closePdf}
        pdfUrl={pdfUrl}
        cargando={pdfCargando}
        titulo={pdfTitulo}
        subtitulo={pdfSubtitulo}
        frameId={pdfFrameId}
      />

      {/* Modal Ver Indicador */}
      {ihVerItem && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.45)', zIndex:9999,
          display:'flex', alignItems:'flex-start', justifyContent:'center',
          p:2, overflowY:'auto', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel" sx={{ bgcolor:IOS.surface, borderRadius:{ xs:'16px', sm:'20px' }, width:'100%', maxWidth:700,
            mx:{ xs:1, sm:0 }, my:2, boxShadow:'0 24px 60px rgba(0,0,0,0.2)', overflow:'hidden' }}>
            <Box className="pharmacy-layout" sx={{ px:2.5, pt:2.5, pb:2, borderBottom:`1px solid ${IOS.separator}`,
              display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <Box>
                <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label }}>
                  Indicadores — {MESES[ihVerItem.mes-1]} {ihVerItem.anio}
                </Typography>
                <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>
                  {ihVerItem.servicio} · DMDU: {ihVerItem.dispDosis}
                </Typography>
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setIhVerItem(null)}
                sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', border:'none',
                  bgcolor:'#E5E5EA', cursor:'pointer', display:'flex',
                  alignItems:'center', justifyContent:'center' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </Box>
            </Box>
            <Box sx={{ p:2.5 }}>
              {/* Tabla det */}
              <Box sx={{ overflowX:'auto', mb:2, WebkitOverflowScrolling:'touch' }}>
                <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.75rem' }}>
                  <thead>
                    <tr>
                      <TH>Servicio</TH><TH></TH>
                      <TH center>Prescripciones</TH><TH center>Unidades</TH>
                      <TH center>Costo Total</TH><TH center>% (A×100)/B</TH>
                    </tr>
                  </thead>
                  <tbody>
                    {(ihVerItem.det||[]).map((d,i)=>(
  <React.Fragment key={i}>
    {/* Fila ATENDIDO */}
    <tr style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:IOS.surface }}>
      <td rowSpan={2} style={{ padding:'8px 12px', fontWeight:700,
        color:IOS.label, borderRight:`1px solid ${IOS.separator}`,
        verticalAlign:'middle', fontSize:'0.8rem' }}>
        {d.servicio}
      </td>
      <td style={{ padding:'6px 10px' }}>
        <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px',
          bgcolor:`${IOS.blue}12` }}>
          <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>
            ATENDIDO (B)
          </Typography>
        </Box>
      </td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700 }}>{d.recetas}</td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700 }}>{d.items}</td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700 }}>
        S/ {parseFloat(d.total||0).toFixed(2)}
      </td>
      <td style={{ padding:'6px 10px', textAlign:'center', color:IOS.label3 }}>—</td>
    </tr>
    {/* Fila DEVUELTO */}
    <tr style={{ borderBottom:`2px solid ${IOS.separator}`, backgroundColor:'#EDFAF2' }}>
      <td style={{ padding:'6px 10px' }}>
        <Box sx={{ display:'inline-flex', px:0.8, py:0.2, borderRadius:'20px',
          bgcolor:'rgba(52,199,89,.15)' }}>
          <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:'#1A7F35' }}>
            DEVUELTO (A)
          </Typography>
        </Box>
      </td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700,
        color:'#1A7F35' }}>{d.cantidadDev}</td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700,
        color:'#1A7F35' }}>{d.cantidadDev}</td>
      <td style={{ padding:'6px 10px', textAlign:'center', fontWeight:700,
        color:'#1A7F35' }}>S/ {parseFloat(d.totalDev||0).toFixed(2)}</td>
      <td style={{ padding:'6px 10px', textAlign:'center' }}>
        <Typography sx={{ fontSize:'0.78rem', fontWeight:800, color:'#1A7F35' }}>
          {pct(d.cantidadDev, d.items)}
        </Typography>
      </td>
    </tr>
  </React.Fragment>
))}
                  </tbody>
                </table>
              </Box>
              {/* Datos cab */}
              <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))',
                gap:1, bgcolor:IOS.bg, borderRadius:'12px', p:1.5 }}>
                {[
                  ['Camas Total', ihVerItem.totalCamas],
                  ['Camas DMDU',  ihVerItem.camas],
                  ['Q.F. SDMDU',  ihVerItem.cantQfSdmdu],
                  ['Q.F. SFT',    ihVerItem.cantQfSft],
                  ['Q.F. Disp.',  ihVerItem.cantQfDisp],
                  ['Q.F. D.Esp.', ihVerItem.cantQfDispEsp],
                  ['Pac. SDMDU',  ihVerItem.sftB1],
                ].map(([l,v])=>(
                  <Box key={l} sx={{ bgcolor:IOS.surface, borderRadius:'10px', p:1 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                      textTransform:'uppercase', letterSpacing:'.05em', mb:0.3 }}>{l}</Typography>
                    <Typography sx={{ fontSize:'1rem', fontWeight:700, color:IOS.label }}>{v}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal Eliminar Indicador */}
      {ihDelItem && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.45)', zIndex:9999,
          display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'20px', p:0, width:360, mx:2,
            boxShadow:'0 24px 60px rgba(0,0,0,0.2)', overflow:'hidden' }}>
            <Box sx={{ p:2.5 }}>
              <Box className="pharmacy-layout" sx={{ width:48, height:48, borderRadius:'50%', bgcolor:'#FFF0EF',
                display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                  stroke={IOS.red} strokeWidth="2" strokeLinecap="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </Box>
              <Typography sx={{ fontWeight:700, fontSize:'0.95rem', color:IOS.label,
                textAlign:'center', mb:0.5 }}>Eliminar indicador</Typography>
              <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, textAlign:'center', mb:2.5 }}>
                ¿Eliminar los indicadores de <strong style={{ color:IOS.label }}>
                  {MESES[ihDelItem.mes-1]} {ihDelItem.anio}
                </strong>? No se puede deshacer.
              </Typography>
              <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.5, justifyContent:'center' }}>
                <Box className="pharmacy-action" component="button" onClick={()=>setIhDelItem(null)}
                  sx={{ height:34, px:2, borderRadius:'10px', border:`1px solid ${IOS.separator}`,
                    bgcolor:IOS.surface, cursor:'pointer', fontSize:'0.8rem',
                    fontWeight:600, color:IOS.label }}>Cancelar</Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" onClick={eliminarIndicador} disabled={!puedeEliminar||ihEliminando}
                  sx={{ height:34, px:2.5, borderRadius:'10px', border:'none',
                    bgcolor:ihEliminando?'#E5E5EA':IOS.red,
                    cursor:ihEliminando?'default':'pointer',
                    display:'flex', alignItems:'center', gap:0.8 }}>
                  {ihEliminando&&<CircularProgress size={12} sx={{ color:'white' }} />}
                  <Typography sx={{ fontSize:'0.8rem', fontWeight:700,
                    color:ihEliminando?'#8E8E93':'white' }}>
                    {ihEliminando?'Eliminando...':'Sí, eliminar'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal Consolidado */}
      {modalConsol && (
        <Box className="devoluciones-page pharmacy-page pharmacy-overlay" sx={{ position:'fixed', inset:0, bgcolor:'rgba(0,0,0,0.45)', zIndex:9999,
          display:'flex', alignItems:{ xs:'flex-end', sm:'center' }, justifyContent:'center', backdropFilter:'blur(4px)' }}>
          <Box className="pharmacy-modal-panel" sx={{ bgcolor:IOS.surface, borderRadius:{ xs:'20px 20px 0 0', sm:'20px' },
            width:{ xs:'100%', sm:360 }, mx:{ xs:0, sm:2 }, pb:{ xs:'env(safe-area-inset-bottom)', sm:0 },
            boxShadow:'0 24px 60px rgba(0,0,0,0.2)', overflow:'hidden' }}>
            <Box className="pharmacy-layout" sx={{ px:2.5, pt:2.5, pb:2, borderBottom:`1px solid ${IOS.separator}`,
              display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <Typography sx={{ fontWeight:700, fontSize:'0.92rem', color:IOS.label }}>PDF Consolidado</Typography>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={()=>setModalConsol(false)}
                sx={{ width:32, minWidth:32, height:32, minHeight:32, p:0, flexShrink:0, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA',
                  cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </Box>
            </Box>
            <Box sx={{ p:2.5 }}>
              <Typography sx={{ fontSize:'0.75rem', color:IOS.label2, mb:2 }}>
                Suma todos los servicios registrados del rango en un solo formato MINSA.
              </Typography>
              <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:1.5 }}>
                <Box><Lbl>Desde</Lbl>
                  <Sel value={cDesde} onChange={e=>setCDesde(parseInt(e.target.value))}>
                    {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                  </Sel>
                </Box>
                <Box><Lbl>Hasta</Lbl>
                  <Sel value={cHasta} onChange={e=>setCHasta(parseInt(e.target.value))}>
                    {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                  </Sel>
                </Box>
              </Box>
              <Box sx={{ mb:2.5 }}><Lbl>Año</Lbl>
                <Sel value={cAnio} onChange={e=>setCAnio(parseInt(e.target.value))}>
                  {ANIOS.map(a=><option key={a} value={a}>{a}</option>)}
                </Sel>
              </Box>
              <Box className="pharmacy-layout pharmacy-action" component="button" onClick={imprimirConsolidado}
                sx={{ width:'100%', height:38, borderRadius:'10px', border:'none', bgcolor:'#AF52DE',
                  cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <Typography sx={{ fontSize:'0.85rem', fontWeight:700, color:'white' }}>Generar PDF</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}